import React, { useState, useEffect, useRef } from "react";
import DETH_ABI from "../ABI/DETH_ABI.json";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { UserCheck, getUserCollection } from "../actions/v1/user";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import randomInteger from "random-int";
import { MdOutlineAdd } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import delete_png from "../assets/images/del.png";
import $ from "jquery";
import "@metamask/legacy-web3";
import Select from "react-select";
import CONFIG from "../lib/config";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import Convert from "../views/separate/Convert";
import isEmpty from "../lib/isEmpty";
import Web3 from "web3";
import Web3Utils from "web3-utils";
import MULTIPLE from "../ABI/MULTIPLE.json";
import SINGLE from "../ABI/SINGLE.json";
import { getReceipt } from "../actions/v1/getReceiptFunc";
import { LazyMinting, ipfsImageHashGet } from "../actions/v1/token";
import { connectWallet, WalletConnect } from "../views/hooks/useWallet";
import {
  GetCategoryAction,
  CreateTokenValidationAction,
  TokenAddItemAction,
  TokenAddOwnerAction,
  WenlamboConvert,
} from "../actions/v1/token";
import { Account_Connect, Account_disConnect } from "../actions/redux/action";
//redux
import { AddressUserDetails_GetOrSave_Action } from "../actions/v1/user";
import { network } from "./network";
import Market from "../ABI/market";

import { AddCollectionRef } from "./separate/create_collection";
import { getcmslistinhome } from "../actions/v1/report";
import { GetGasFees, signMessage } from "../actions/contractProvider";
import { GetServiceFee } from "../actions/contractProvider";
import { NumberOnly } from "../lib/common";
import { NumberChange } from "../lib/common";
import { Row, Col } from "react-bootstrap";
import { constantContractMethods } from "./hooks/useParamsforSign";
import {
  NumANdDotOnly,
  Number_Decimal,
} from "../actions/commonfunction";
import pricesvg from "../assets/images/price_svg.svg";
import timedsvg from "../assets/images/timed_svg.svg";
import unlimitedsvg from "../assets/images/unlimited_svg.svg";
import NftAudio from "../components/NftAudio";
import NftVideo from "../components/NftVideo";
import {
  assertOnChainMetadataUri,
  parseErc1155MintMetadata,
  parseErc721MintTokenId,
  toTokenIdString,
  verifyNftMetadataDocument,
} from "../lib/nftMintVerification";

var initialformvalue = {
  currencySymbol: "",
  tokenSymbol: "",
  tokenAddr: {},
  tokenABI: {},
  singleContract: "",
  multipleContract: "",
  BNBPROVIDER: "",
  networkVersion: "",
  chainId: "",
  Chainid: 0,
  trade: "",
};

const mapdata = [
  { value: "Discord", label: "Discord", classname: "fab fa-discord" },
  { value: "Instagram", label: "Instagram", classname: "fab fa-instagram" },
  { value: "Linkedin", label: "Linkedin", classname: "fab fa-linkedin" },
  { value: "Whatsapp", label: "Whatsapp", classname: "fab fa-whatsapp" },
  { value: "Twitter", label: "Twitter", classname: "fab fa-twitter" },
  { value: "Slack", label: "Slack", classname: "fab fa-slack" },
  { value: "Telegram", label: "Telegram", classname: "fab fa-telegram" },
  { value: "Github", label: "Github", classname: "fab fa-github" },
  { value: "Facebook", label: "Facebook", classname: "fab fa-facebook-f" },
  { value: "Others", label: "Others", classname: "fas fa-hashtag" },
  // Add more data items here as needed
];

// toast.configure();
const dashboardRoutes = [];
let toasterOption = CONFIG.toasterOption;

// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

export default function CreateSingle(props) {
  const dispatch = useDispatch();

  const Wallet_Details = useSelector((state) => state.wallet_connect_context);

  // const networkoption = [
  //   { value: config.currencySymbol, label: config.currencySymbol },
  //   { value: config.tokenSymbol, label: config.tokenSymbol },
  // ];

  const { ...rest } = props;
  const navigate = useNavigate();

  const [category, setCategory] = React.useState(false);

  var pathVal = "";
  const location = useLocation();
  if (location.pathname) {
    if (location.pathname.split("/").length >= 2) {
      pathVal = location.pathname.split("/")[1];
    }
  }

  const [location_pathname, Set_location_pathname] = useState(pathVal);
  var CollectibleType_val =
    location_pathname === "create-single"
      ? CONFIG.singleType
      : CONFIG.multipleType;

  const [CollectibleType, Set_CollectibleType] = useState(CollectibleType_val);
  const [TokenFilePreUrl, setTokenFilePreUrl] = useState("");
  const [imgfilename, setimgfilename] = useState("");
  const [fileSizes, setfilesize] = useState(0);
  const [TokenFile, setTokenFile] = useState("");
  const [TokenFilePreReader, setTokenFilePreReader] = useState("");
  const [ValidateError, setValidateError] = useState({ TokenPrice: "" });
  const [PutOnSale, setPutOnSale] = useState(false);
  const [PutOnSaleType, setPutOnSaleType] = useState("UnLimitedAuction");
  const [TokenBid, setTokenBid] = useState(true);
  const [Unlockoncepurchased, Set_Unlockoncepurchased] = useState(false);
  const [MinimumBid, Set_MinimumBid] = useState(0);
  const [Clocktime, set_Clocktime] = useState("");
  const [MintHashVal, Set_MintHashVal] = useState("");
  const [EndClocktime, set_EndClocktime] = useState("");
  const [TokenPrice, setTokenPrice] = useState(0);
  const [YouWillGet, Set_YouWillGet] = useState(0);
  const [TokenName, setTokenName] = useState("");
  const [TokenDescription, setTokenDescription] = useState("");
  const [TokenRoyalities, setTokenRoyalities] = useState("");
  const [TokenProperties, setTokenProperties] = useState("");
  const [UnLockcontent, Set_UnLockcontent] = useState("");
  const [TokenQuantity, Set_TokenQuantity] = useState(1);
  const [CoinName, setCoinNames] = useState("");
  const [ApproveCallStatus, setApproveCallStatus] = useState("init");
  const [ApproveTrade, setApproveTrade] = useState("init");

  const [StartDate, Set_StartDate] = useState("Select Start Date");
  const [EndDate, Set_EndDate] = useState("Select End Date");
  const [priceoption, setPriceoption] = React.useState([]);
  const [FormSubmitUserClicked, Set_FormSubmitUserClicked] = useState(false);
  const [UserAccountBal, Set_UserAccountBal] = useState(0);
  const [TokenCategory, setTokenCategory] = useState({ label: "" });
  const [UserCollection, setUserCollection] = useState("");
  const [UserCollectionId, setUserCollectionId] = useState("");
  const [CollectionList, setCollectionList] = useState([]);
  const [CategoryOption, setCategoryOption] = useState([]);
  const [TokenImages, setTokenImage] = useState({});
  const [ipfshash, setIpfsHash] = useState("");
  const [ipfshashurl, setipfshashurl] = useState("");
  const [additionalImage, setAdditionalImage] = useState("");
  const [ipfsmetatag, set_ipfsmetatag] = useState("");
  const [MintCallStatus, setMintCallStatus] = useState("init");
  const [ContractAddressUser, set_ContractAddressUser] = useState(
    ContractAddressUser_val,
  );
  const [networkoption, setnetworkoption] = React.useState([]);
  const [config, setconfig] = React.useState(initialformvalue);
  const [iscurrency, setiscurrency] = React.useState();

  const selectedNetworkOption =
    networkoption.find(
      (option) =>
        String(option?.value).toUpperCase() ===
        String(config?.currencySymbol).toUpperCase(),
    ) || null;

  const [accountDetailssss, setaccountDetailssss] = useState({});
  const [decimal, setdecimal] = React.useState();
  const [check, setcheck] = React.useState(false);
  const [originalImage, setoriginalImagee] = useState("");
  const [approvecheck, setapprovecheck] = useState(false);
  const [fullcategory, setFullcategory] = useState({});
  const [CategorywithSubcategory, setCategorywithSubcategory] = useState({});
  const [agree, SetAgree] = useState({
    original: false,
    termsandcondition: false,
  });
  const [admincheck, SetAdmincheck] = useState(false);
  const [CMS, SetCMS] = useState({});
  const [cmsindex, SetCmsIndex] = useState({});

  const [ListNFT, SetListNFT] = useState(false);
  const [LazyMint, SetLazyMint] = useState(false);
  const [ListedQuantity, SetListedQuantity] = useState(0);
  const [PutOnSaleQuantity, SetPutOnSaleQuantity] = useState(0);
  const [OwnerQuantity, SetOwnerQuantity] = useState(0);

  const [Randomname, setRandomName] = useState("");
  const [_nonce, setNonceHash] = useState("");
  const [signature, setSignatureHash] = useState("");
  const [LazymintStatus, SetLazymintStatus] = useState("init");

  const CreateCollectionForwardRef = useRef();

  const [socialLinks, SetSocialLinks] = useState([]);
  const [filterRows, setFilterRows] = useState([]);
  const [choosencollection, SetChoosenCollection] = useState({});
  const [NFTProperties, setNFTProperties] = useState([]);
  const [ThumbFile, SetThumbFile] = useState({});
  const [IPFS, SetIPFS] = useState({});
  const [WhiteListUser, SetWhiteListUser] = useState([]);
  const [WhiteListOptions, SetWhiteListOptions] = useState([]);

  useEffect(() => {
    if (Array.isArray(WhiteListUser) && WhiteListUser?.length > 0) {
      let quant = 0;
      WhiteListUser.map((val) => {
        if (NumberChange(val?.Quantity)) {
          quant = quant + NumberChange(val?.Quantity);
        }
      });
      SetOwnerQuantity(
        quant > NumberChange(TokenQuantity)
          ? quant - NumberChange(TokenQuantity)
          : NumberChange(TokenQuantity) - quant,
      );
    } else {
      SetOwnerQuantity(TokenQuantity);
    }
  }, [TokenQuantity, WhiteListUser]);

  useEffect(() => {
    if (
      Array.isArray(Wallet_Details?.alldata?.WhiteListUser) &&
      Wallet_Details?.alldata?.WhiteListUser?.length > 0
    ) {
      let arr = [];
      Wallet_Details.alldata.WhiteListUser.map((val) => {
        if (
          !isEmpty(val) &&
          String(Wallet_Details?.UserAccountAddr).toLowerCase() !=
            String(val).toLowerCase()
        ) {
          arr.push({
            label: String(val).toLowerCase(),
            value: String(val).toLowerCase(),
          });
        }
      });

      SetWhiteListOptions(arr);
      SetWhiteListUser([]);
    } else {
      SetWhiteListOptions([]);
      SetWhiteListUser([]);
    }
  }, [Wallet_Details?.alldata]);

  const mappedData = mapdata.map((item) => ({
    value: item.value,
    label: item.label,
    classname: item.classname,
  }));

  var ContractAddressUser_val =
    location_pathname == "create-single"
      ? Wallet_Details.networkConfiguration.singleContract
      : Wallet_Details.networkConfiguration.multipleContract;

  useEffect(() => {
    getCollection();
    GetAdmin();
  }, [Wallet_Details.UserAccountAddr]);

  useEffect(() => {
    setconfig(Wallet_Details?.networkConfiguration);
  }, [Wallet_Details?.networkConfiguration]);

  async function getCollection() {
    let Singlee = Wallet_Details.networkConfiguration.singleContract;
    let Multiplee = Wallet_Details.networkConfiguration.multipleContract;
    let payload = {
      userAddress: Wallet_Details.UserAccountAddr,
    };
    if (location_pathname === "create-multiple") {
      payload.NFTType = "MULTIPLE";
      payload.Type = Multiplee;
    } else {
      payload.NFTType = "SINGLE";
      payload.Type = Singlee;
    }
    let userCollectiondata = await getUserCollection(payload);

    let Collectionlist = [];
    if (
      userCollectiondata &&
      userCollectiondata.message &&
      userCollectiondata.message.data &&
      isEmpty(userCollectiondata.message.data.collections) === false
    ) {
      userCollectiondata.message.data.collections.map((item, index) => {
        Collectionlist.push({
          ...item,
          ...{
            name: "userCollection",
            value: item._id,
            label: item.collectionName,
            // custon:item.customurl
          },
        });
      });
    }
    Collectionlist.push({
      name: "userCollection",
      value: "create",
      label: (
        <div className="drop_static_create">
          <Link
            onClick={() =>
              CreateCollectionForwardRef.current.AddCollection_Click()
            }
          >
            Create Collections
          </Link>
        </div>
      ),
    });
    setCollectionList(Collectionlist);
  }

  useEffect(() => {
    if (Wallet_Details && Wallet_Details.tokenAddress.length > 0) {
      setPriceoption(Wallet_Details.tokenAddress);
    }
  }, [Wallet_Details.tokenAddress]);

  useEffect(() => {
    GetCategoryCall();
    CreateItemValidation(FormSubmitUserClicked);
  }, [Wallet_Details.UserAccountAddr, TokenFilePreReader, CoinName]);

  useEffect(() => {
    console.log(
      "Wallet_Details.networkoption-->",
      Wallet_Details.networkoption,
    );
    if (Wallet_Details && Wallet_Details?.networkoption?.length > 0) {
      setnetworkoption(Wallet_Details.networkoption);
    }
  }, [Wallet_Details?.networkoption]);

  const selectChange = async (e) => {
    let accountDetails, configdata;
    if (e?.name === "networkname") {
      setCoinNames("");

      const selectedNetwork = String(e.value).toLowerCase();
      if (
        selectedNetwork === String(CONFIG.binance).toLowerCase() ||
        selectedNetwork === "bnb"
      ) {
        configdata = network.BSC;
      } else if (
        selectedNetwork === String(CONFIG.etherium).toLowerCase() ||
        selectedNetwork === "eth" ||
        selectedNetwork === "ethereum"
      ) {
        configdata = network.ETH;
      }

      if (configdata) {
        setconfig(configdata);
        accountDetails = await switchNetwork(configdata);
      }
    }
    setaccountDetailssss(accountDetails);

    if (e && e.name && e.label && e.value) {
      //networkname
      switch (e.name) {
        case "TokenCategory":
          setTokenCategory(e);
          break;
        case "networkname":
          break;
        case "userCollection": {
          if (e.value == "create") {
            setUserCollection("");
            setUserCollectionId("");
          } else {
            setUserCollection(e.label);
            setUserCollectionId(e.value);
            if (e?.SubCategory && e?.CategoryId && e?.Category) {
              setCategorywithSubcategory({
                category: e.Category,
                subcategory: e.SubCategory,
                id: e.CategoryId,
                display: e.Category + "-" + e.SubCategory,
                disabecategory: true,
                collection: e.label,
              });
            } else if (CategorywithSubcategory?.collection == UserCollection) {
              setCategorywithSubcategory({});
            }
          }
        }
        default:
      }
    } else {
      toast.warning("please connect your wallet", toasterOption);
    }
  };

  useEffect(() => {
    if (choosencollection?._id) {
      selectChange(choosencollection);
    }
  }, [CollectionList]);

  const GetAdmin = async () => {
    if (
      !isEmpty(
        Wallet_Details?.UserAccountAddr &&
          Wallet_Details.networkConfiguration.TradeContract &&
          Wallet_Details.providerss,
      )
    ) {
      let web3 = new Web3(Wallet_Details.providerss);
      let CoursetroContract = new web3.eth.Contract(
        Market,
        Wallet_Details.networkConfiguration.TradeContract,
      );
      try {
        let controwner = await CoursetroContract.methods.owner().call();
        if (
          Wallet_Details?.UserAccountAddr.toLowerCase() ==
          controwner.toLowerCase()
        ) {
          SetAdmincheck(true);
        } else {
          SetAdmincheck(false);
        }
      } catch (err) {
        console.error("GetAdmin_error", err);
      }
    }
  };

  async function GetCategoryCall() {
    let resp = await GetCategoryAction();
    if (resp && resp.data && isEmpty(resp.data.list) === false) {
      let CategoryOption = [];
      let ind = null;
      if (resp && resp.data && isEmpty(resp.data.list) === false) {
        resp.data.list.map((item, index) => {
          ind =
            (isEmpty(TokenImages) || TokenImages.activate === false) &&
            String(item.name).toLowerCase() === "film"
              ? index
              : -1;
          CategoryOption.push({
            name: "TokenCategory",
            value: item._id,
            label: item.name,
          });
        });
      }
      if (ind > -1) {
        delete CategoryOption[ind];
      }
      setCategoryOption(CategoryOption);
      setFullcategory(resp.data.list);
    }
  }

  async function CreateItemValidation(chk) {
    let approvedata = {
      type: CollectibleType,
      contractAddress:
        location_pathname === "create-single"
          ? Wallet_Details.networkConfiguration.singleContract
          : Wallet_Details.networkConfiguration.multipleContract,
    };
    let check = await orderApprovecheck(approvedata);
    setapprovecheck(check); //
    if (chk) {
      let ValidateError = {};
      if (config.Chainid === 0) {
        ValidateError.network = '"network" is not allowed to be empty';
      }
      if (CoinName === "" && PutOnSaleType !== "UnLimitedAuction") {
        ValidateError.TokenPrice = '"Currency or Token" must be required';
      }
      if (TokenName === "") {
        ValidateError.TokenName = '"Name" is not allowed to be empty';
      } else {
        if (CONFIG.nameFormat.test(TokenName)) {
          ValidateError.TokenName = '"Emoji" is not allowed';
        } else if (TokenName?.length > 20) {
          ValidateError.TokenName = "Name must be less than 20";
        }
      }
      if (TokenRoyalities === "") {
        ValidateError.TokenRoyalities =
          '"Royalties" is not allowed to be empty';
      } else if (isNaN(TokenRoyalities) === true) {
        ValidateError.TokenRoyalities = '"Royalties" must be a number';
      } else if (TokenRoyalities > 20) {
        ValidateError.TokenRoyalities =
          '"Royalties" must be less than or equal to 20';
      }
      if (TokenFilePreUrl === "") {
        ValidateError.photo = '"File" is required';
      } else if (30000000 < fileSizes) {
        ValidateError.photo = '"File" Must be below 30mb';
      }
      if (isEmpty(CategorywithSubcategory)) {
        ValidateError.TokenCategory = '"Category" is required';
      }
      if (isEmpty(UserCollection)) {
        ValidateError.userCollection = "Collection is not allowed to be Empty";
      }

      if (Unlockoncepurchased === true && UnLockcontent === "") {
        ValidateError.UnLockcontent = '"Locked content" is required';
      }
      if (
        Number(OwnerQuantity) === 0 ||
        isNaN(OwnerQuantity) === true ||
        Number(OwnerQuantity) < 1
      ) {
        ValidateError.TokenQuantity = '"Quantity" must be greater than 0';
      }
      if (ListNFT) {
        if (isEmpty(ListedQuantity)) {
          ValidateError.ListedQuantity = "List Quantity must be greater than 0";
        } else if (Number(ListedQuantity) % 1 !== 0) {
          ValidateError.ListedQuantity = "List Quantity must be Whole Number";
        } else if (Number(ListedQuantity) > OwnerQuantity) {
          ValidateError.ListedQuantity =
            "List Quantity must be less than " + OwnerQuantity;
        }
      }
      if (PutOnSale === true && PutOnSaleType === "FixedPrice") {
        if (
          TokenPrice === "" ||
          (isNaN(TokenPrice) === true && Number(TokenPrice) === 0)
        ) {
          ValidateError.TokenPrice = '"Price" must be a number';
        } else if (Number(TokenPrice) === 0 && !admincheck) {
          ValidateError.TokenPrice = '"Price" must be greater than zero';
        } else if (CoinName === "") {
          ValidateError.TokenPrice = 'Currency or Token" must be required';
        }
        if (YouWillGet === 0) {
          ValidateError.TokenPrice = '"Price" must be Greater than 0';
        }
        if (Number(ListedQuantity) < 1) {
          ValidateError.ListedQuantity = "Quantity must be Greater than 0";
        }
      }
      if (PutOnSale === true && PutOnSaleType === "TimedAuction") {
        if (MinimumBid === "") {
          ValidateError.MinimumBid = '"Bid Price" must be a number';
        } else if (CoinName === "") {
          ValidateError.MinimumBid = 'Currency or Token" must be required';
        }
        if (Clocktime === "") {
          ValidateError.Clocktime = '"Start Clock Time " cant be a number';
        } else if (Clocktime === "Select Start Date") {
          ValidateError.Clocktime = '"Start Clock Time " cant be a number';
        } else if (Clocktime === "Invalid Date") {
          ValidateError.Clocktime = '"Start Clock Time " cant be a number';
        }
        //   else if (Clocktime<new Date()) {
        //     ValidateError.Clocktime = 'Select time greater than current time';
        // }
        else if (EndClocktime) {
          if (EndClocktime < new Date(Clocktime)) {
            ValidateError.Clocktime = "Select time lesser than Expiration time";
          }
        }
        if (EndClocktime === "") {
          ValidateError.EndClocktime = '"End Clock Time " cant be a number';
        } else if (EndClocktime === "Select End Date") {
          ValidateError.EndClocktime = '"End Clock Time " cant be a number';
        } else if (EndClocktime === "Invalid Date") {
          ValidateError.EndClocktime = '"End Clock Time " cant be a number';
        } else if (EndClocktime === "Invalid Date") {
          ValidateError.EndClocktime = '"End Clock Time " cant be a number';
        } else if (Clocktime) {
          if (EndClocktime < new Date(Clocktime)) {
            ValidateError.EndClocktime =
              "Select time greater than Starting time";
          }
        }
      }
      if (PutOnSale) {
        if (isEmpty(PutOnSaleQuantity)) {
          ValidateError.PutOnSaleQuantity = "Quantity is Required";
        } else if (Number(PutOnSaleQuantity) > Number(OwnerQuantity)) {
          ValidateError.PutOnSaleQuantity = "Quantity must be less than Copies";
        } else if (Number(PutOnSaleQuantity) > Number(ListedQuantity)) {
          ValidateError.PutOnSaleQuantity =
            "Quantity must be less than Listed Quantity";
        } else if (Number(PutOnSaleQuantity) % 1 !== 0) {
          ValidateError.PutOnSaleQuantity = "Quantity must be whole number";
        }
      }
      if (
        TokenQuantity === "" ||
        (isNaN(TokenQuantity) === true && TokenQuantity === 0)
      ) {
        ValidateError.TokenQuantity = '"Number of copies" must be a number';
      }
      if (TokenQuantity % 1 !== 0) {
        ValidateError.TokenQuantity = "Quantity must be whole number";
      }
      if (!agree?.original) {
        ValidateError.original = "This field is required";
      }
      if (!agree?.termsandcondition) {
        ValidateError.termsandcondition = "This field is required";
      }
      if (socialLinks?.length > 0) {
        socialLinks.map((val, ind) => {
          if (isEmpty(val.url)) {
            ValidateError["url" + ind] = "Url cannot be Empty";
          }
          if (isEmpty(val.urlfor)) {
            ValidateError["urlfor" + ind] = "Url cannot be Empty";
          }
        });
      }
      if (WhiteListUser?.length > 0) {
        let whitelistquantity = 0;
        let errorquantityindex = [];
        WhiteListUser.map((val, ind) => {
          if (isEmpty(val?.Address)) {
            ValidateError["whitelistaddress" + ind] =
              "Wallet Address cannot be Empty";
          } else {
            try {
              Web3Utils.toChecksumAddress(val?.Address);
            } catch {
              ValidateError["whitelistaddress" + ind] =
                "Enter Valid Wallet Address";
            }
          }
          if (isEmpty(val?.Quantity)) {
            ValidateError["whitelistquantity" + ind] = "Enter Quantity";
          } else if (NumberChange(val?.Quantity) <= 0) {
            ValidateError["whitelistquantity" + ind] =
              "Quantity Must be Greater Than '0'";
          } else if (NumberChange(val?.Quantity) % 1 != 0) {
            ValidateError["whitelistquantity" + ind] =
              "Quantity Must be a Number not a Decimal";
          } else {
            if (
              whitelistquantity + NumberChange(val?.Quantity) >
              NumberChange(TokenQuantity)
            ) {
              // ValidateError["whitelistquantity" + ind] = "Quantity Must be less than "+( NumberChange(TokenQuantity) - whitelistquantity)
              errorquantityindex.push(ind);
            } else {
              whitelistquantity =
                whitelistquantity + NumberChange(val?.Quantity);
            }
          }
        });
        if (errorquantityindex?.length > 0) {
          errorquantityindex.map((val) => {
            if (whitelistquantity < TokenQuantity) {
              ValidateError["whitelistquantity" + val] =
                "Quantity Must be less than " +
                (NumberChange(TokenQuantity) - whitelistquantity);
            } else {
              ValidateError["whitelistquantity" + val] =
                "No Quantity Available";
            }
          });
        }
      }
      setValidateError(ValidateError);
      return ValidateError;
    } else {
      return {};
    }
  }

  const PriceCalculate = async (data = {}) => {
    let price = typeof data.price != "undefined" ? data.price : TokenPrice;
    let weii = price * CONFIG.decimalvalues;
    let per = (weii * Wallet_Details.Service_Fee_seller) / 1e20;
    let mulWei = parseFloat(weii - per);
    let getVal = mulWei / CONFIG.decimalvalues;
    Set_YouWillGet(getVal.toFixed(4));
  };

  const selectFileChange = (e) => {
    if (Wallet_Details.UserAccountAddr == "") {
      toast.warning(" connect your wallet", toasterOption);
    }
    let validExtensions = [];
    if (e.target && e.target.files) {
      let { name, id, value } = e.target;
      if (id == "file") {
        validExtensions = [
          "png",
          "gif",
          "webp",
          "mp4",
          "PNG",
          "jpg",
          "JPEG",
          "jpeg",
          "JPG",
          "mp3",
          "aac",
          "AAC",
          "flac",
          "FLAC",
          "WEBM",
          "webm",
          "ogv",
          "OGV",
        ]; //array of valid extensions
      } else {
        validExtensions = ["png", "webp", "PNG", "jpg", "JPEG", "jpeg", "JPG"]; //array of valid extensions
      }
      let reader = new FileReader();
      let file = e.target.files[0];
      let fileName = file.name;
      let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
      if ($.inArray(fileNameExt, validExtensions) === -1) {
        toast.error(
          "Only these file types are accepted : " + validExtensions.join(", "),
          toasterOption,
        );
        return false;
      }
      const fileSize = file.size;
      if (30000000 < fileSize) {
        toast.error("File size exceeds 30 MB", toasterOption);
        return false;
      } else {
        if (id == "file") {
          if (file?.type?.includes("image")) {
            SetThumbFile({});
          }
          setimgfilename(file.name);
          setfilesize(fileSize);
          setTokenFile(file);
          let url = reader.readAsDataURL(file);
          reader.onloadend = function (e) {
            if (reader.result) {
              setTokenFilePreReader(reader.result);
            }
          }.bind(this);
          setTokenFilePreUrl(e.target.value);
        } else if (id == "thumb") {
          SetThumbFile(file);
        }
      }
    }
  };

  const CheckedChange = (e) => {
    if (e && e.target && e.target.name) {
      if (e.target.name === "putonsale") {
        if (PutOnSale === false) {
          setPutOnSale(true);
          if (PutOnSaleType === "") {
            setPutOnSaleType("FixedPrice");
          }
          SetPutOnSaleQuantity(1);
        } else {
          setPutOnSale(false);
          setPutOnSaleType("UnLimitedAuction");
          setTokenBid(true);
          SetPutOnSaleQuantity(0);
          setTokenPrice(0);
        }
      } else if (e.target.name === "ListNFT") {
        if (ListNFT === false) {
          SetListedQuantity(1);
          SetListNFT(true);
          setPutOnSale(true);
          setPutOnSaleType("FixedPrice");
          SetPutOnSaleQuantity(1);
        } else {
          SetListedQuantity(0);
          SetListNFT(false);
          setPutOnSale(false);
          setPutOnSaleType("UnLimitedAuction");
          setTokenBid(true);
          SetPutOnSaleQuantity(0);
        }
      } else if (e.target.name === "unlockoncepurchased") {
        if (Unlockoncepurchased === false) {
          Set_Unlockoncepurchased(true);
        } else {
          Set_Unlockoncepurchased(false);
        }
      }
    }
  };

  const changePutOnSaleType = (type) => {
    if (type == "TimedAuction") {
      if (CollectibleType == 721) SetListedQuantity(1);
      if (Wallet_Details && isEmpty(Wallet_Details.tokenAddress) === false) {
        let bnbs = Wallet_Details.tokenAddress.filter(
          (item) =>
            item.label != Wallet_Details.networkConfiguration.currencySymbol,
        );
        setPriceoption(bnbs);
      }
    } else if (
      Wallet_Details?.tokenAddress &&
      isEmpty(Wallet_Details.tokenAddress) === false
    ) {
      setPriceoption(
        Wallet_Details &&
          Wallet_Details.tokenAddress &&
          Wallet_Details.tokenAddress,
      );
    }
    setPutOnSaleType(type);
    if (type === "FixedPrice") {
      Set_MinimumBid(0);
      set_Clocktime("");
      set_EndClocktime("");
      if (CollectibleType == 721) SetListedQuantity(1);
    } else if (type == "TimedAuction") {
      setTokenPrice(0);
      SetListedQuantity(1);
    } else if (type == "UnLimitedAuction") {
      SetListedQuantity(1);
      Set_MinimumBid(0);
      set_Clocktime("");
      set_EndClocktime("");
      setTokenPrice(0);
    }
  };
  const priceoptionfunc = (e) => {
    setCoinNames(e.label);
    setdecimal(e.Decimal);
    // setiscurrency(e.currency)
  };

  const inputChange = (e) => {
    if (
      e &&
      e.target &&
      typeof e.target.value != "undefined" &&
      e.target.name
    ) {
      let value = e.target.value;
      const re = /^[0-9]+([.][0-9]+)?$/; //with decimal
      const re1 = /^[0-9\b]+$/; // only [0-9]
      switch (e.target.name) {
        case "TokenPrice":
          value = NumANdDotOnly(value);
          setTokenPrice(value);
          PriceCalculate({ price: value });

          // if (value !== "" && isNaN(value) === false && value > 0) {
          //   setTokenPrice(value);
          //   PriceCalculate({ price: value });
          // } else {
          //   setValidateError(ValidateError);
          //   setTokenPrice("0");
          //   PriceCalculate({ price: 0 });
          // }
          break;
        case "TokenName":
          setTokenName(value);
          break;
        case "TokenDescription":
          setTokenDescription(value);
          break;
        case "TokenRoyalities":
          value = NumANdDotOnly(value);
          setTokenRoyalities(value);
          break;
        case "TokenProperties":
          setTokenProperties(value);
          break;
        case "UnLockcontent":
          Set_UnLockcontent(value);
          break;
        case "MinimumBid":
          value = NumANdDotOnly(value);
          Set_MinimumBid(value);
          break;
        case "TokenQuantity":
          value = NumberOnly(value);
          Set_TokenQuantity(value);
          break;
        case "ListedQuantity":
          value = NumberOnly(value);
          SetListedQuantity(value);
          break;
        case "PutOnSaleQuantity":
          value = NumberOnly(value);
          SetPutOnSaleQuantity(value);
          break;
        default:
        // code block
      }
    }
  };

  async function DateChange(from, val) {
    if (from === "StartDateDropDown") {
      if (val === "PickStartDate") {
        ModalAction("calendar_modal", "show");
      } else {
        let newdat;
        Set_StartDate(val);
        let myDate = new Date();
        if (val === "RightAfterListing") {
          newdat = myDate.setDate(myDate.getDate());
        } else {
          newdat = myDate.setDate(myDate.getDate() + parseInt(val));
        }
        let newdate = new Date(newdat);
        set_Clocktime(newdate);
      }
    } else if (from === "EndDateDropDown") {
      if (val === "PickEndDate") {
        ModalAction("calendar_modal_expire", "show");
      } else {
        Set_EndDate(val);
        let myDate = new Date();
        let newdat = myDate.setDate(myDate.getDate() + parseInt(val));
        let newdate = new Date(newdat);
        set_EndClocktime(newdate);
      }
    }
  }

  async function ModalAction(id, type) {
    window.$("#" + id).modal(type);
    if (id === "calendar_modal") {
      if (Clocktime) {
        let dt = new Date(Clocktime);
        let dt1 = dt.toLocaleString();
        Set_StartDate(dt1);
      }
    } else if (id === "calendar_modal_expire") {
      if (EndClocktime) {
        let dt = new Date(EndClocktime);
        let dt1 = dt.toLocaleString();
        Set_EndDate(dt1);
      }
    }
  }

  async function CreateItem() {
    debugger;
    if (Wallet_Details.UserAccountAddr !== "") {
      let useractive = await UserCheck({
        currAddr: Wallet_Details?.UserAccountAddr,
      });
      if (!useractive?.userValue?.activate) {
        toast.error("User banned by the admin");
        return false;
      }
      let check = await orderApprovecheck();

      Set_FormSubmitUserClicked(true);
      let errors = await CreateItemValidation(true);
      let errorsSize = Object.keys(errors).length;
      if (errorsSize !== 0) {
        toast.error(
          "Form validation error. Fix all mistakes and submit again",
          toasterOption,
        );
        return false;
      } else if (Wallet_Details.providerss) {
        if (config.Chainid === Wallet_Details.networkConfiguration.Chainid) {
          if (Wallet_Details.providerss == null) {
            toast.error("Please Connect to BINANCE Network", toasterOption);
          } else {
            if (
              typeof Wallet_Details.UserAccountBal === "undefined" ||
              Wallet_Details.UserAccountBal === null ||
              Wallet_Details.UserAccountBal === 0
            ) {
              Set_UserAccountBal(0);
            } else {
              // usercurbal = balance / config.decimalvalues;
              Set_UserAccountBal(Wallet_Details.UserAccountBal);
            }
            if (Wallet_Details.UserAccountBal === 0) {
              toast.error("Insufficient balance", toasterOption);
              return false;
            }
            let TokenCategory_label = TokenCategory.label;
            let payload = {
              TokenName,
              TokenRoyalities,
              image: TokenFile,
              TokenCategory_label,
              PutOnSaleType,
              TokenPrice,
            };
            const resp = await CreateTokenValidationAction(payload);
            if (resp && resp.data) {
              if (resp.data.errors) {
                let errors = resp.data.errors;
                let errorsSize = Object.keys(errors).length;
                if (errorsSize !== 0) {
                  setValidateError(errors);
                  toast.error(
                    "Form validation error. Fix all mistakes and submit again",
                    toasterOption,
                  );
                } else {
                  setValidateError({});
                  if (
                    Wallet_Details.networkConfiguration.Chainid ===
                    config.Chainid
                  ) {
                    let generator = require("generate-password");

                    let web3 = new Web3(Wallet_Details.providerss);
                    if (web3) {
                      let randomNum = randomInteger(10000000, 100000000);
                      let password = generator.generate({
                        length: 10,
                        numbers: true,
                      });
                      if (web3) {
                        let web3RpcPro = new Web3(web3.providers);
                        const to = Wallet_Details.UserAccountAddr;
                        const _amount =
                          TokenPrice == "" || TokenPrice == undefined
                            ? 0
                            : web3RpcPro.utils.toWei(String(TokenPrice));
                        const _nonce = Date.now();

                        setRandomName(password);
                        let tot = _nonce + Number(randomNum);
                        setNonceHash(tot);
                        const result = web3RpcPro.utils.soliditySha3(
                          to,
                          _amount,
                          password,
                          tot,
                        );
                        try {
                          const signhash = await web3.eth.personal.sign(
                            result,
                            to,
                          );

                          if (signhash) {
                            setSignatureHash(signhash);
                          }
                        } catch (err) {
                          return toast.error("Try again ....");
                        }
                      }
                    }
                    if (LazyMint) {
                      setApproveCallStatus("done");
                    }
                    window.$("#create_item_modal").modal("show");
                  } else {
                    toast.warn("CoiName is not Valid");
                  }
                }
              }
            }
          }
        }
      } else {
        if (config.Chainid === 0) {
          toast.error("Please select network ");
        } else {
          toast.error("Please switch network", toasterOption);
          setTimeout(() => {
            window.location = "/";
          }, 1000);
        }
      }
    } else {
      toast.warning("please connect your wallet");
    }
  }

  async function switchNetwork(configdata) {
    let type = "";
    let networkConfiguration = configdata;
    let accountDetails;
    if (configdata) {
      if (
        localStorage.walletConnectType &&
        localStorage.walletConnectType != null &&
        localStorage.walletConnectType == "MetaMask"
      ) {
        type = "MetaMask";
      } else if (
        localStorage.walletConnectType &&
        localStorage.walletConnectType == "WalletConnect" &&
        localStorage.walletConnectType != null
      ) {
        type = "WalletConnect";
      }

      window.$("#connect_modal").modal("hide");
      accountDetails = await connectWallet(type, configdata.Chainid);
      const connectedProvider = accountDetails?.web3?._provider;
      const web3 = connectedProvider ? new Web3(connectedProvider) : null;

      if (web3) {
        const chainId = await web3.eth.getChainId();
        console.log("🚀 ~ switchNetwork ~ chainId:", chainId);

        if (chainId === network.ETH.Chainid) {
          networkConfiguration = network.ETH;
        } else if (chainId === network.BSC.Chainid) {
          networkConfiguration = network.BSC;
        }
      }
      if (accountDetails && connectedProvider) {
        dispatch({
          type: Account_Connect,
          Account_Detail: {
            UserAccountAddr: accountDetails?.accountAddress,
            UserAccountBal: accountDetails?.coinBalance,
            WalletConnected: "true",
            Wen_Bln: accountDetails?.tokenBalance,
            Accounts: accountDetails?.accountAddress,
            providerss: accountDetails?.web3?._provider,
            networkConfiguration: networkConfiguration,
          },
        });
      } else {
        toast.warning("please connect your wallet");
      }
    }
    return accountDetails;
  }

  async function ApproveCall() {
    try {
      if (Wallet_Details.UserAccountAddr === "") {
        toast.warning("OOPS!..connect Your Wallet", toasterOption);
        return false;
      } else {
        let ipfsimghashget;
        setApproveCallStatus("processing");
        let senddata = {
          Image: TokenFile,
          name: TokenName,
          // image: config.IPFS_IMG + "/" + ipfsimghashget.data.ipfsval,
          desc:
            TokenDescription !== ""
              ? TokenDescription
              : "This Token was Created in EDAFACE NFT platform",
          Creator: Wallet_Details.UserAccountAddr.toLowerCase(),
          collection: UserCollection,
        };
        if (NFTProperties?.length > 0) {
          senddata.Properties = JSON.stringify(NFTProperties);
        }
        if (ThumbFile?.type) {
          senddata.Thumb = ThumbFile;
        }
        try {
          ipfsimghashget = await ipfsImageHashGet(senddata);
        } catch (err) {
          console.error("ipfsImageHashGet_erro", err);
        }
        if (ipfsimghashget && ipfsimghashget.data && ipfsimghashget.data.data) {
          SetIPFS(ipfsimghashget.data.data);
          if (
            ipfsimghashget.data.data.mediaUrl ||
            ipfsimghashget.data.data.ipfsval !== ""
          ) {
            setoriginalImagee(ipfsimghashget.data.data.image);

            setIpfsHash(ipfsimghashget.data.data.ipfsval);
            setipfshashurl(
              ipfsimghashget.data.data.mediaUrl ||
                `${CONFIG.IPFS_IMG}/${ipfsimghashget.data.data.ipfsval}`,
            );

            setAdditionalImage(ipfsimghashget.data.data.additionalImage);
            if (
              ipfsimghashget.data.data.tokenUri ||
              ipfsimghashget.data.data.ipfsmetadata
            ) {
              let ipfsurls = ipfsimghashget.data.data.ipfsmetadata;
              set_ipfsmetatag(
                ipfsimghashget.data.data.tokenUri ||
                  `${CONFIG.IPFS_IMG}/${ipfsurls}`,
              );
              toast.success("IPFS Uploaded Successfully", toasterOption);
              setApproveCallStatus("done");
            } else {
              setApproveCallStatus("tryagain");
              toast.error("Try Again", CONFIG.toasterOption);
            }
          } else {
            setApproveCallStatus("tryagain");
            toast.error("Try Again", CONFIG.toasterOption);
          }
        } else {
          setApproveCallStatus("tryagain");
          toast.error("Try Again", CONFIG.toasterOption);
        }
      }
    } catch (error) {
      setApproveCallStatus("tryagain");
      toast.error("Try Again", CONFIG.toasterOption);
    }
  }

  const MintCall = async () => {
    setMintCallStatus("processing");
    let web3 = new Web3(Wallet_Details.providerss);
    if (Wallet_Details.UserAccountAddr === "") {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }
    try {
      await verifyNftMetadataDocument(ipfsmetatag, {
        expectedName: TokenName,
      });
    } catch (error) {
      console.error("metadata_preflight_error", error);
      setMintCallStatus("tryagain");
      toast.error(
        `Metadata is not publicly ready: ${error.message}`,
        toasterOption,
      );
      return false;
    }
    let gas;
    await web3.eth.getGasPrice().then(async (result) => {
      gas = result;
    });

    let signData = {
      TokenName: TokenName,
      NFTBalance: Number(OwnerQuantity),
      NFTOwner: Wallet_Details.UserAccountAddr,
    };
    console.log("signData-->", signData);
    let signMsg = await signMessage(
      Wallet_Details.providerss,
      Wallet_Details?.UserAccountAddr,
      constantContractMethods?.["whitelistMinting"],
      signData,
      Wallet_Details.networkConfiguration.Chainid,
      Wallet_Details.networkConfiguration.TradeContract,
    );
    console.log("signMsg-->", signMsg);
    if (!signMsg.hash) {
      setMintCallStatus("tryagain");
      return toast.error(signMsg.err, toasterOption);
    }

    signData = {
      TokenName: TokenName,
      NFTBalance: Number(OwnerQuantity),
      type: constantContractMethods?.["whitelistMinting"],
      signature: signMsg.hash,
      ContractAddress: Wallet_Details.networkConfiguration.TradeContract,
      NFTOwner: Wallet_Details?.UserAccountAddr,
      salt: signMsg.salt,
      nonce: signMsg.nonce,
      deadline: signMsg.deadline,
      chainId: Wallet_Details.networkConfiguration.Chainid,
    };

    let CoursetroContract = null;
    let contractCall = null;
    let gasfeecalculated;

    CoursetroContract = new web3.eth.Contract(
      Market,
      Wallet_Details.networkConfiguration.TradeContract,
    );

    let CurrServiceFee = await GetServiceFee("default", CoursetroContract);

    try {
      // if(WhiteListUser?.some((val) => NumberChange(val?.Quantity) > 0) ){

      // total[0] - amount, total[1] - listQty, total[2] -  royal, total[3] - NFT Type, total[4] - litType
      let listwhitelist = [];

      if (WhiteListUser?.some((val) => NumberChange(val?.Quantity) > 0)) {
        listwhitelist = [
          Wallet_Details.UserAccountAddr,
          ...WhiteListUser?.map((val) => val?.Address),
        ];
      }

      let encoded = await CoursetroContract.methods
        .whitelistMinting(
          ipfsmetatag,
          listwhitelist,
          listwhitelist?.length > 0
            ? WhiteListUser?.map((val) => val?.Quantity)
            : [],
          [
            OwnerQuantity,
            CollectibleType,
            window.web3.toWei(TokenRoyalities).toString(),
            ListedQuantity,
            CurrServiceFee?.key,
          ],
          ListNFT,
        )
        .encodeABI();

      gasfeecalculated = await GetGasFees({
        web3: web3,
        encoded: encoded,
        contractaddress: Wallet_Details.networkConfiguration.TradeContract,
        value: CurrServiceFee?.Minting_fee,
        accountAddress: Wallet_Details?.UserAccountAddr,
      });

      contractCall = await CoursetroContract.methods.whitelistMinting(
        ipfsmetatag,
        listwhitelist,
        listwhitelist?.length > 0
          ? WhiteListUser?.map((val) => val?.Quantity)
          : [],
        [
          OwnerQuantity,
          CollectibleType,
          window.web3.toWei(TokenRoyalities).toString(),
          ListedQuantity,
          CurrServiceFee?.key,
        ],
        ListNFT,
      );
    } catch (err) {
      console.error("whitelistMinting_error", err);
    }
    try {
      var mintCall = null;
      var receipt = null;
      var handle = null;

      if (contractCall != null) {
        await contractCall
          .send({
            from: Wallet_Details.UserAccountAddr,
            value: CurrServiceFee?.Minting_fee,
            // gasLimit: parseInt(gasfeecalculated?.gasdata * 1.5, 10),
            // gasPrice: gasfeecalculated?.gasPrice,
          })
          .on("transactionHash", async (transactionHash) => {
            mintCall = transactionHash;
            if (mintCall) {
              // handle = setInterval(async () => {
              receipt = await getReceipt(web3, transactionHash);
              clr1();
              // }, 8000);
            }
          });
      }
    } catch (e) {
      toast.error("Mint not Successfully", toasterOption);
      setMintCallStatus("tryagain");
    }
    async function clr1() {
      if (receipt != null) {
        clearInterval(handle);
        if (receipt.status === true) {
          Set_MintHashVal(mintCall);
          let Status = "true";
          let someString;
          const expectedUri = IPFS?.tokenUri || ipfsmetatag;
          try {
            if (NumberChange(CollectibleType) === 1155) {
              const [minted] = parseErc1155MintMetadata({
                web3,
                receipt,
                contractAddress:
                  Wallet_Details.networkConfiguration.multipleContract,
                expectedUris: [expectedUri],
              });
              await assertOnChainMetadataUri({
                web3,
                abi: MULTIPLE,
                contractAddress:
                  Wallet_Details.networkConfiguration.multipleContract,
                method: "uri",
                tokenId: minted.tokenId,
                expectedUri,
              });
              someString = toTokenIdString(minted.tokenId);
            } else {
              const tokenId = parseErc721MintTokenId({
                web3,
                receipt,
                contractAddress:
                  Wallet_Details.networkConfiguration.singleContract,
              });
              await assertOnChainMetadataUri({
                web3,
                abi: SINGLE,
                contractAddress:
                  Wallet_Details.networkConfiguration.singleContract,
                method: "tokenURI",
                tokenId,
                expectedUri,
              });
              someString = toTokenIdString(tokenId);
            }
          } catch (error) {
            console.error("mint_metadata_reconciliation_error", error);
            setMintCallStatus("done");
            toast.error(
              `Mint confirmed, but metadata verification failed. Do not mint again; save transaction ${mintCall} for support.`,
              toasterOption,
            );
            return;
          }
          toast.success("Your Token Added Successfully", toasterOption);
          let TokenAddItemPayload = {
            Image: IPFS?.image,
            ipfsimage: IPFS?.ipfsval,
            Name: TokenName,
            Count: someString,
            Description: TokenDescription,
            Price: TokenPrice,
            Royalities: TokenRoyalities,
            Category_label: CategorywithSubcategory.category,
            Bid: TokenBid,
            tokenProperty: TokenProperties,
            Owner: Wallet_Details.UserAccountAddr,
            Creator: Wallet_Details.UserAccountAddr,
            CategoryId: CategorywithSubcategory.id,
            Quantity: TokenQuantity,
            Balance: TokenQuantity,
            // ContractAddress:Wallet_Details.networkConfiguration.TradeContract,
            ContractAddress:
              location_pathname === "create-single"
                ? Wallet_Details.networkConfiguration.singleContract
                : Wallet_Details.networkConfiguration.multipleContract,
            Status: Status,
            HashValue: mintCall,
            Type: CollectibleType,
            MinimumBid: 0,
            Clocktime: "",
            EndClocktime: "",
            UnLockcontent: "",
            PutOnSale: PutOnSale,
            PutOnSaleType: PutOnSaleType,
            CoinName: CoinName,
            additionalImage: IPFS?.additionalImage,
            collection: UserCollection,
            collectionId: UserCollectionId,
            SelectedNetwork: Wallet_Details?.networkConfiguration?.Chainid,
            decimal: decimal,
            Subcategory: CategorywithSubcategory.subcategory,
            TermsandConditions: agree.termsandcondition,
            Randomname: Randomname,
            _nonce: _nonce,
            signature: signature,
            SocialLinks: JSON.stringify(socialLinks),
            SelectedNetworkName: Wallet_Details?.networkConfiguration?.label,
            thumb: IPFS?.thumb ? IPFS?.thumb : "",
            thumb_additionalImage: IPFS?.thumb_additionalImage
              ? IPFS?.thumb_additionalImage
              : "",
            thumb_ipfs: IPFS?.thumb_ipfs ? IPFS?.thumb_ipfs : "",
            metadata: IPFS?.MetFile ? IPFS?.MetFile : "",
            metadata_ipfs: IPFS?.ipfsmetadata ? IPFS?.ipfsmetadata : "",
            storageAssetId: IPFS?.assetId || "",
            tokenUri: IPFS?.tokenUri || ipfsmetatag,
            mediaUrl: IPFS?.mediaUrl || "",
            animationUrl: IPFS?.animationUrl || "",
            mediaContentType: IPFS?.mediaContentType || "",
            signData,
          };
          if (Unlockoncepurchased === true) {
            TokenAddItemPayload.UnLockcontent = UnLockcontent;
          }
          if (NFTProperties?.length > 0) {
            TokenAddItemPayload.Properties = JSON.stringify(NFTProperties);
          }

          if (PutOnSale === true) {
            if (PutOnSaleType === "FixedPrice") {
              TokenAddItemPayload.Price = TokenPrice;
            } else if (PutOnSaleType === "TimedAuction") {
              TokenAddItemPayload.MinimumBid = MinimumBid;
              TokenAddItemPayload.Clocktime = Clocktime;
              TokenAddItemPayload.EndClocktime = EndClocktime;
              //TokenAddItemPayload.CoinName = Wallet_Details.networkConfiguration.tokenSymbol;
            }
          }
          let resp = await TokenAddItemAction(TokenAddItemPayload);
          let TokenAddOwnerPayload = {
            Count: someString,
            Price: TokenPrice,
            Owner: Wallet_Details.UserAccountAddr,
            Balance: OwnerQuantity,
            Quantity: OwnerQuantity,
            ContractAddress:
              location_pathname === "create-single"
                ? Wallet_Details.networkConfiguration.singleContract
                : Wallet_Details.networkConfiguration.multipleContract,
            Type: CollectibleType,
            tokenCreator: Wallet_Details.UserAccountAddr,
            HashValue: mintCall,
            CoinName: CoinName,
            Status: Status,
            collection: UserCollection,
            collectionId: UserCollectionId,
            SelectedNetwork: Wallet_Details?.networkConfiguration?.Chainid,
            decimal: decimal,
            PutOnSaleType: PutOnSaleType,
            Randomname: Randomname,
            _nonce: _nonce,
            signature: signature,
            ListedQuantity: ListedQuantity,
            ListNFT: ListNFT,
            putonsalequantity: PutOnSaleQuantity,
            signData,
          };
          if (PutOnSaleType === "TimedAuction") {
            TokenAddOwnerPayload.MinimumBid = MinimumBid;
            TokenAddOwnerPayload.Clocktime = Clocktime;
            TokenAddOwnerPayload.EndClocktime = EndClocktime;
          }
          if (WhiteListUser?.length > 0) {
            TokenAddOwnerPayload.WhiteListUser = JSON.stringify(WhiteListUser);
          }
          await TokenAddOwnerAction(TokenAddOwnerPayload);

          setMintCallStatus("done");
          setTimeout(() => window.$("#create_item_modal").modal("hide"), 1000);
          setTimeout(() => navigate("/my-items"), 1200);
        }
      }
    }
  };

  async function getapproveFun() {
    setApproveTrade("processing");
    let web3 = new Web3(Wallet_Details.providerss);

    let address =
      location_pathname === "create-single"
        ? Wallet_Details.networkConfiguration.singleContract
        : Wallet_Details.networkConfiguration.multipleContract;

    try {
      let ConnectContract = await new web3.eth.Contract(
        CollectibleType == "721" ? SINGLE : MULTIPLE,
        address,
      );
      let encoded = await ConnectContract.methods
        .setApprovalForAll(
          Wallet_Details.networkConfiguration.TradeContract,
          true,
        )
        .encodeABI();
      let gasfeecalculated = await GetGasFees({
        web3: web3,
        encoded: encoded,
        contractaddress: address,
        accountAddress: Wallet_Details?.UserAccountAddr,
      });
      let contract_Method_Hash = await ConnectContract.methods
        .setApprovalForAll(
          Wallet_Details.networkConfiguration.TradeContract,
          true,
        )
        .send({
          from: Wallet_Details.UserAccountAddr,
          gasLimit: parseInt(gasfeecalculated?.gasdata * 1.5, 10),
          gasPrice: gasfeecalculated?.gasPrice,
        })
        .on("transactionHash", (transactionHash) => {
          return transactionHash;
        });

      let HashValue, receipt;
      try {
        HashValue = contract_Method_Hash.transactionHash
          ? contract_Method_Hash.transactionHash
          : contract_Method_Hash;

        receipt = await web3.eth.getTransactionReceipt(HashValue);
      } catch (err) {
        console.error("🚀 ~ getapproveFun ~ err:", err);
      }

      let need_data = {
        status: receipt.status,
        HashValue: receipt.transactionHash,
      };
      if (need_data.status === true) {
        setApproveTrade("done");
      } else {
        setApproveTrade("tryagain");
      }
      return need_data;
    } catch (e) {
      console.error("getapproveFun_error", e);
      return false;
    }
  }

  async function orderApprovecheck(item) {
    if (Wallet_Details.providerss == null) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }
    let web3 = new Web3(Wallet_Details.providerss);
    try {
      let MultiContract = new web3.eth.Contract(
        item.type === 721 ? SINGLE : MULTIPLE,
        item.contractAddress,
      );
      let status = await MultiContract.methods
        .isApprovedForAll(
          Wallet_Details.UserAccountAddr,
          Wallet_Details.networkConfiguration.TradeContract,
        )
        .call();
      return !status;
    } catch (e) {
      return false;
    }
  }

  const SettokenCategory = (cat, subcat) => {
    setCategorywithSubcategory({
      category: cat.name,
      subcategory: subcat,
      id: cat._id,
      display: cat.name + "-" + subcat,
    });
    setCategory(!category);
  };

  const Oncancel = async (imgType) => {
    if (imgType == "file") {
      setimgfilename("");
      setfilesize(0);
      setTokenFile("");
      setTokenFilePreReader("");
      setTokenFilePreUrl("");
      toast.success("Cancelled successfully");
    } else {
      SetThumbFile({});
      toast.success("Cancelled successfully");
    }
  };

  const addFilters = (type) => {
    if (type == "properties") {
      if (NFTProperties.length < 10) {
        setNFTProperties([...NFTProperties, ...[{ key: "", value: "" }]]);
      } else {
        toast.error("Already added 10 Properties", 1000);
      }
    } else {
      if (filterRows.length < 10) {
        setFilterRows([...filterRows, { filters: "" }]);
        SetSocialLinks([...socialLinks, { url: "" }]);
      } else {
        toast.error("Already added 10 links", 1000);
      }
    }
  };

  const removeFilters = (index, from) => {
    if (from == "properties") {
      setNFTProperties([
        ...NFTProperties.slice(0, index),
        ...NFTProperties.slice(index + 1, NFTProperties?.length),
      ]);
    } else {
      const list = [...filterRows];
      let currlink = socialLinks;
      list.splice(index, 1);
      currlink.splice(index, 1);
      setFilterRows(list);
      SetSocialLinks([...currlink]);
    }
  };

  const OnChange = (e, index, id) => {
    let currlinks = socialLinks;
    setValidateError({});
    if (e?.target?.id) {
      const { id, value, name } = e.target;
      if (id == "Address") {
        SetWhiteListUser([
          ...WhiteListUser.slice(0, index),
          ...[
            {
              ...WhiteListUser?.[index],
              [name]: name == "Quantity" ? NumberOnly(value) : value,
            },
          ],
          ...WhiteListUser.slice(index + 1, WhiteListUser.length),
        ]);
      } else if (id == "key" || id == "value") {
        setNFTProperties([
          ...NFTProperties.slice(0, index),
          ...[
            {
              ...NFTProperties[index],
              ...{
                [id]: value,
              },
            },
          ],
          ...NFTProperties.slice(index + 1, NFTProperties.length),
        ]);
      } else {
        if (id == "Address") {
          SetWhiteListUser([
            ...WhiteListUser.slice(0, index),
            ...[
              {
                ...WhiteListUser[index],
                Address: e?.value,
              },
            ],
            ...WhiteListUser.slice(index + 1, WhiteListUser.length),
          ]);
        } else {
          filterRows.map((val, ind) => {
            if (ind == index) {
              currlinks[ind][id] = value;
            }
          });
        }
      }
    } else if (e?.value) {
      if (id) {
        SetWhiteListUser([
          ...WhiteListUser.slice(0, index),
          ...[
            {
              ...WhiteListUser?.[index],
              [id]: e.value,
            },
          ],
          ...WhiteListUser.slice(index + 1, WhiteListUser.length),
        ]);
      } else {
        const { classname, label, value } = e;

        filterRows.map((val, ind) => {
          if (ind == index) {
            currlinks[ind].urlfor = value;
            currlinks[ind].classname = classname;
          }
        });
      }
    }
    SetSocialLinks([...currlinks]);
  };

  const LazyMintFunc = async () => {
    try {
      SetLazymintStatus("processing");

      let signData = {
        TokenName: TokenName,
        NFTBalance: Number(TokenQuantity),
        NFTOwner: Wallet_Details.UserAccountAddr,
      };

      let signMsg = await signMessage(
        Wallet_Details.providerss,
        Wallet_Details?.UserAccountAddr,
        constantContractMethods?.["lazyminting"],
        signData,
        Wallet_Details.networkConfiguration.Chainid,
        Wallet_Details.networkConfiguration.TradeContract,
      );

      if (!signMsg.hash) {
        SetLazymintStatus("tryagain");
        return toast.error(signMsg.err, toasterOption);
      }

      signData = {
        ...signData,
        type: constantContractMethods?.["lazyminting"],
        signature: signMsg.hash,
        ContractAddress: Wallet_Details.networkConfiguration.TradeContract,
        salt: signMsg.salt,
        nonce: signMsg.nonce,
        deadline: signMsg.deadline,
        chainId: Wallet_Details.networkConfiguration.Chainid,
      };

      let senddata = {
        Name: TokenName,
        File: [TokenFile],
        Description: TokenDescription,
        Creator: Wallet_Details.UserAccountAddr.toLowerCase(),
        TokenQuantity: TokenQuantity,
        Thumbfile: "",
        type: "singlemint",
        Price: TokenPrice,
        Royalities: TokenRoyalities,
        Category_label: CategorywithSubcategory.category,
        Bid: TokenBid,
        Properties: TokenProperties,
        Owner: Wallet_Details.UserAccountAddr,
        CategoryId: CategorywithSubcategory.id,
        Quantity: TokenQuantity,
        Balance: TokenQuantity,
        ContractAddress: Wallet_Details.networkConfiguration.singleContract,
        Status: "true",
        HashValue: "notminted",
        Type: CollectibleType,
        MinimumBid: 0,
        Clocktime: "",
        EndClocktime: "",
        UnLockcontent: "",
        PutOnSale: PutOnSale,
        PutOnSaleType: PutOnSaleType,
        CoinName: CoinName,
        additionalImage: additionalImage,
        collection: UserCollection,
        collectionId: UserCollectionId,
        SelectedNetwork: Wallet_Details?.networkConfiguration?.Chainid,
        decimal: decimal,
        Subcategory: CategorywithSubcategory.subcategory,
        TermsandConditions: agree.termsandcondition,
        Randomname: Randomname,
        _nonce: _nonce,
        signature: signature,
        PutOnSaleQuantity: PutOnSaleQuantity,
        ListNFT: ListNFT,
        ListedQuantity: ListedQuantity,
        SocialLinks: JSON.stringify(socialLinks),
        TokenQuantity: TokenQuantity,
        SelectedNetworkName: Wallet_Details?.networkConfiguration?.label,
        signData,
      };
      if (Unlockoncepurchased === true) {
        senddata.UnLockcontent = UnLockcontent;
      }
      if (WhiteListUser?.length > 0) {
        senddata.WhiteListUser = JSON.stringify(WhiteListUser);
      }

      if (PutOnSale === true) {
        if (PutOnSaleType === "FixedPrice") {
          senddata.Price = TokenPrice;
        } else if (PutOnSaleType === "TimedAuction") {
          senddata.MinimumBid = MinimumBid;
          senddata.Clocktime = Clocktime;
          senddata.EndClocktime = EndClocktime;
        }
      }
      let Resp = await LazyMinting(senddata);
      if (Resp?.data?.success == "success") {
        toast.success(Resp?.data?.msg, 1000);
        SetLazymintStatus("done");
        window.$("#create_item_modal").modal("hide");
        navigate("/my-items");
      } else {
        toast.error(Resp?.data?.msg, 1000);
        SetLazymintStatus("tryagain");
      }
    } catch (err) {
      toast.error(err.toString, 1000);
      SetLazymintStatus("tryagain");
    }
  };

  useEffect(() => {
    GetCMS();
  }, []);

  const GetCMS = async () => {
    let reqdata = {
      load: "all",
      type: "Create-Single-Multi-Upload",
    };
    let convers = await getcmslistinhome(reqdata);
    if (convers && convers?.data?.length > 0) {
      let cmskeys = {};
      convers.data.map((val, ind) => {
        cmskeys[val.question] = ind;
      });
      SetCMS(convers.data);
      SetCmsIndex(cmskeys);
    }
  };

  const AddField = (type) => {
    if (type == "whitelist") {
      if (WhiteListUser.length < WhiteListOptions?.length) {
        SetWhiteListUser([
          ...WhiteListUser,
          ...[{ Address: "", Quantity: "" }],
        ]);
      } else {
        if (WhiteListOptions?.length > 0) {
          toast.error("All Whitelist User Added", 1000);
        } else {
          toast.error("No White List Users", 1000);
        }
      }
    } else if (type == "properties") {
      if (NFTProperties.length < 10) {
        setNFTProperties([...NFTProperties, ...[{ key: "", value: "" }]]);
      } else {
        toast.error("Already added 10 Properties", 1000);
      }
    } else {
      if (filterRows.length < 10) {
        setFilterRows([...filterRows, { filters: "" }]);
        SetSocialLinks([...socialLinks, { url: "" }]);
      } else {
        toast.error("Already added 10 links", 1000);
      }
    }
  };

  const RemoveField = (index, from) => {
    if (from == "whitelist") {
      SetWhiteListUser([
        ...WhiteListUser.slice(0, index),
        ...WhiteListUser.slice(index + 1, WhiteListUser?.length),
      ]);
    } else if (from == "properties") {
      setNFTProperties([
        ...NFTProperties.slice(0, index),
        ...NFTProperties.slice(index + 1, NFTProperties?.length),
      ]);
    } else {
      const list = [...filterRows];
      let currlink = socialLinks;
      list.splice(index, 1);
      currlink.splice(index, 1);
      setFilterRows(list);
      SetSocialLinks([...currlink]);
    }
  };

  const checkSelectedTimeValid = (type, value) => {
    if (type == "startTime") {
      if (value?._d >= new Date()) {
        set_Clocktime(value?._d);
        setValidateError({});
      }
      // else{
      //     toast.error("Select time greater than current time");
      // }
    } else {
      if (Clocktime) {
        if (value?._d >= new Date(Clocktime)) {
          set_EndClocktime(value?._d);
          setValidateError({});
        }
      } else {
        set_EndClocktime(value?._d);
        setValidateError({});
      }
    }
  };

  const validStartTime = (current) => {
    const selectedDate = new Date(current);

    return selectedDate >= new Date().setHours(0, 0, 0, 0);
  };

  const validEndTime = (current) => {
    const selectedDate = new Date(current);
    return (
      selectedDate >
      new Date(Clocktime ? Clocktime : Date.now()).setHours(0, 0, 0, 0)
    );
  };

  return (
    <div className="inner_header">
      <Header />
      <ScrollToTopOnMount />

      <AddCollectionRef
        ref={CreateCollectionForwardRef}
        GetCollection={getCollection}
        SetCurrCollection={SetChoosenCollection}
      />

      <div className={" inner_pageheader"}>
        <div className={"container"}>
          <Row>
            <Col xs={12} sm={12} md={12}>
              <div className="d-flex align-items-center">
                <Link to="/create">
                  <i className="fas fa-arrow-left mr-3 arrow_back"></i>
                </Link>
                <h3 className="section-head mb-0 sec_he_sm">
                  {location_pathname === "create-single" && "Create Single NFT"}
                  {location_pathname === "create-multiple" &&
                    "Create Multiple NFTs"}
                </h3>
              </div>
            </Col>
          </Row>
        </div>
        <div className="container mt-5">
          <Row>
            <Col xs={12} sm={4} md={4}>
              <label className="primary_label">Preview</label>
              <div className="single_collectible masonry mx-0">
                <div className="item">
                  <div className="card_inner_item">
                    <div className="d-flex justify-content-between">
                      <div></div>
                    </div>
                    <div className="remaintime mt-3">
                      <div className="item_inner_img">
                        {(TokenFilePreUrl.split(".").pop() === "mp4" ||
                          TokenFilePreUrl.split(".").pop() === "m4v" ||
                          TokenFilePreUrl.split(".").pop() === "mov" ||
                          TokenFilePreUrl.split(".").pop() === "webm" ||
                          TokenFilePreUrl.split(".").pop() === "WEBM" ||
                          TokenFilePreUrl.split(".").pop() === "OGV" ||
                          TokenFilePreUrl.split(".").pop() === "ogv") && (
                          <NftVideo
                            src={
                              TokenFilePreReader !== ""
                                ? TokenFilePreReader
                                : require("../assets/images/noimage.png")
                            }
                            mediaName={TokenFilePreUrl}
                            label="NFT video preview"
                          />
                        )}

                        {TokenFilePreUrl.split(".").pop() === "mp3" && (
                          <NftAudio
                            src={
                              TokenFilePreReader !== ""
                                ? TokenFilePreReader
                                : require("../assets/images/noimage.png")
                            }
                            cover={CONFIG.AudioImg}
                            mimeType="audio/mpeg"
                            label="NFT audio preview"
                            preload="none"
                          />
                        )}

                        {(TokenFilePreUrl.split(".").pop() === "webp" ||
                          TokenFilePreUrl.split(".").pop() === "WEBP" ||
                          TokenFilePreUrl.split(".").pop() === "gif" ||
                          TokenFilePreUrl.split(".").pop() === "jpg" ||
                          TokenFilePreUrl.split(".").pop() === "GIF" ||
                          TokenFilePreUrl.split(".").pop() === "JPG" ||
                          TokenFilePreUrl.split(".").pop() === "JPEG" ||
                          TokenFilePreUrl.split(".").pop() === "jpeg" ||
                          TokenFilePreUrl.split(".").pop() === "png" ||
                          TokenFilePreUrl.split(".").pop() === "PNG") && (
                          <img
                            src={
                              TokenFilePreReader !== ""
                                ? TokenFilePreReader
                                : require("../assets/images/noimage.png")
                            }
                            id="imgPreview"
                            alt="Collections"
                            className="img-fluid"
                          />
                        )}
                        {TokenFilePreReader === "" && (
                          <img
                            src={require("../assets/images/noimage.png")}
                            id="imgPreview"
                            alt="Collections"
                            className="img-fluid"
                          />
                        )}

                        {/* 

                        <img src={require('../assets/images/noimage.png')} id="imgPreview" alt="Collections" className="img-fluid" /> */}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-end">
                      <div>
                        {/* <h3 className="my-2 ">
                          <span className="text-gray">
                            { <span className="mr-1">Not for sale </span>}
                           
                          </span> </h3> */}

                        <button
                          className="btn btn_purple_sm bg-theme"
                          data-toggle="modal"
                          data-target="#place_bid_multiple_modal"
                        >
                          {" "}
                          <span>Open for Bids 1 of 1</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {(TokenFile?.type?.includes("video") ||
                TokenFile?.type?.includes("audio")) && (
                <>
                  <label className="primary_label">
                    Background Image Preview (Optional)
                  </label>
                  <div className="single_collectible masonry mx-0">
                    <div className="item">
                      <div className="card_inner_item">
                        <div className="d-flex justify-content-between">
                          <div></div>
                        </div>
                        <div className="remaintime mt-3">
                          <div className="item_inner_img">
                            <img
                              src={
                                ThumbFile?.type
                                  ? URL.createObjectURL(ThumbFile)
                                  : require("../assets/images/noimage.png")
                              }
                              id="imgPreview"
                              alt="Collections"
                              className="img-fluid"
                            />
                          </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-end">
                          <div>
                            <button
                              className="btn btn_purple_sm bg-theme"
                              data-toggle="modal"
                            >
                              {" "}
                              <span>Open for Bids 1 of 1</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Col>

            <Col xs={12} sm={8} md={8}>
              <form className="formCls">
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <div className="crt_topdisplay">
                      <div>
                        <label className="primary_label" htmlFor="inputEmail4">
                          Upload file
                        </label>
                        {cmsindex?.["Create-Single-Multi-Upload"] ||
                        cmsindex?.["Create-Single-Multi-Upload"] == 0 ? (
                          <p
                            className="form_note mt-1"
                            dangerouslySetInnerHTML={{
                              __html:
                                CMS[cmsindex?.["Create-Single-Multi-Upload"]]
                                  ?.answer,
                            }}
                          ></p>
                        ) : (
                          <p className="form_note mt-1">
                            JPG, JPEG, PNG, GIF, WEBP, WEPM, OGV, MP3, FLAC, AAC
                            or MP4. Max 30 megabytes
                          </p>
                        )}
                      </div>
                      <div className="crt_buttons_display">
                        <div className="file_btn btn primary_btn me-2">
                          Upload
                          <input
                            className="inp_file"
                            type="file"
                            name="file"
                            id="file"
                            accept="audio/*,video/*,image/*"
                            onChange={selectFileChange}
                          />
                        </div>
                        <div
                          className="file_btn btn primary_btn"
                          onClick={() => Oncancel("file")}
                        >
                          Cancel
                        </div>
                      </div>
                      {ValidateError.photo && (
                        <span className="text-danger img-file mt-3">
                          {ValidateError.photo}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {(TokenFile?.type?.includes("video") ||
                  TokenFile?.type?.includes("audio")) && (
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <div className="crt_topdisplay">
                        <div>
                          <label
                            className="primary_label"
                            htmlFor="inputEmail4"
                          >
                            Upload background image (optional)
                          </label>
                          <p className="form_note mt-1">
                            JPG, JPEG, PNG or WEBP. Max 30 megabytes. If no
                            image is uploaded, the default background will be
                            used.
                          </p>
                        </div>
                        <div className="crt_buttons_display">
                          <div className="file_btn btn primary_btn me-2">
                            Upload
                            <input
                              className="inp_file"
                              type="file"
                              name="file"
                              id="thumb"
                              accept="image/*"
                              onChange={selectFileChange}
                            />
                          </div>
                          <div
                            className="file_btn btn primary_btn"
                            onClick={() => Oncancel("thumb")}
                          >
                            Cancel
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {
                  <div className="form-row">
                    <label
                      className="primary_label"
                      htmlFor="networkname-input"
                    >
                      Network
                    </label>

                    <div className="form-row w-100">
                      <div className="form-group col-md-12">
                        <div className="input-group input_grp_style_1">
                          <Select
                            className="yes1 typecontrol3 form-control primary_inp typecontrol"
                            id="networkname"
                            inputId="networkname-input"
                            name="networkname"
                            onChange={selectChange}
                            options={networkoption}
                            placeholder="Select Network"
                            classNamePrefix="react-select"
                            isSearchable={false}
                            value={selectedNetworkOption}
                          />

                          {ValidateError.network && (
                            <span className="text-danger">
                              {ValidateError.network}
                            </span>
                          )}
                        </div>
                        <p className="form_note">
                          Supported blockchains are BNB Smartchain and Ethereum
                          Smartchain
                        </p>
                      </div>
                    </div>
                  </div>
                }
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <div className="d-flex justify-content-between align-items-start grid_toggle">
                      <div>
                        <label className="primary_label" htmlFor="inputEmail4">
                          LazyMint
                        </label>
                        <p className="form_note">
                          To Create NFT in Lazy-Minting by turning on the button
                          .
                        </p>
                      </div>
                      <label className="switch toggle_custom">
                        <input
                          type="checkbox"
                          id="LazyMint"
                          name="LazyMint"
                          onChange={() => {
                            SetLazyMint(!LazyMint);
                            SetWhiteListUser([]);
                          }}
                          checked={LazyMint}
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <div className="d-flex justify-content-between align-items-start grid_toggle">
                      <div>
                        <label className="primary_label" htmlFor="inputEmail4">
                          List NFT
                        </label>
                        <p className="form_note">
                          List Your NFT in the MarketPlace
                        </p>
                      </div>
                      <label className="switch toggle_custom">
                        <input
                          type="checkbox"
                          id="ListNFT"
                          name="ListNFT"
                          onChange={CheckedChange}
                          checked={ListNFT}
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                    {ListNFT && (
                      <div className="d-flex justify-content-between align-items-start grid_toggle">
                        <div>
                          <label
                            className="primary_label"
                            htmlFor="inputEmail4"
                          >
                            Put on Sale
                          </label>
                          <p className="form_note">
                            Decide how you want to sell your minted NFT by
                            turning on the button.
                          </p>
                        </div>
                        <label className="switch toggle_custom">
                          <input
                            type="checkbox"
                            id="putonsale"
                            name="putonsale"
                            onChange={CheckedChange}
                            checked={PutOnSale}
                          />
                          <span className="slider"></span>
                        </label>
                      </div>
                    )}
                    {PutOnSale === false ? (
                      ""
                    ) : (
                      <>
                        <div className="row connect_row mt-3 putonsale_sec">
                          <div className="col-12 col-sm-4 col-md-12 col-lg-4 mb-3">
                            <div
                              className={
                                "create_box create_sing_bx " +
                                (PutOnSaleType === "FixedPrice"
                                  ? "active"
                                  : "inactive")
                              }
                              id="fixedprice"
                              onClick={() => {
                                changePutOnSaleType("FixedPrice");
                              }}
                            >
                              <img
                                src={pricesvg}
                                alt="Fixed Price"
                                className="img-fluid"
                              />
                              <p>Fixed Price</p>
                            </div>
                          </div>

                          {CollectibleType === 721 && (
                            <div className="col-12 col-sm-4 col-md-12 col-lg-4 mb-3">
                              <div
                                className={
                                  "create_box create_sing_bx " +
                                  (PutOnSaleType === "TimedAuction"
                                    ? "active"
                                    : "inactive")
                                }
                                onClick={() => {
                                  changePutOnSaleType("TimedAuction");
                                }}
                              >
                                <img
                                  src={timedsvg}
                                  alt="Timed Auction"
                                  className="img-fluid"
                                />
                                <p>Timed Auction</p>
                              </div>
                            </div>
                          )}

                          <div
                            className="col-12 col-sm-4 col-md-12 col-lg-4 mb-3"
                            onClick={() => {
                              changePutOnSaleType("UnLimitedAuction");
                            }}
                          >
                            <div
                              className={
                                "create_box create_sing_bx " +
                                (PutOnSaleType === "UnLimitedAuction"
                                  ? "active"
                                  : "inactive")
                              }
                            >
                              <img
                                src={unlimitedsvg}
                                alt="Unlimited Auction"
                                className="img-fluid"
                              />

                              <p>Unlimited Auction</p>
                            </div>
                          </div>
                        </div>
                        <div className="content">
                          {PutOnSaleType == "FixedPrice" ? (
                            <div className="">
                              <p className="form-note">
                                <b>Fixed Price</b>
                              </p>
                              <p className="form-note">
                                This means you will only receive one price offer
                                from purchasers
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                          {PutOnSaleType == "TimedAuction" ? (
                            <div className="">
                              <p className="">
                                <b>Timed Auction:</b>
                              </p>
                              <p className="form-note">
                                This means you will receive:
                              </p>
                              <ul>
                                <li>
                                  different bid price offers from
                                  purchasers{" "}
                                </li>
                                <li>
                                  a bid offer is valid at or above the Minimum
                                  Bid price set by the creator
                                </li>
                                <li>
                                  a bid offer is valid within a specified time
                                  frame set by the creator.
                                </li>
                                <li>
                                  The highest bid offer after the auction ends
                                  is the winning bid.
                                </li>
                              </ul>
                            </div>
                          ) : (
                            <></>
                          )}
                          {PutOnSaleType == "UnLimitedAuction" ? (
                            <div>
                              <p>
                                <b>UnLimitedAuction</b>
                              </p>
                              <p className="form-note">
                                This means there is no Minimum Bid and no
                                Specified Duration for the auction to take
                                place. As the minter of the NFT, you determine
                                the Minimum Bid and the Specified Duration of
                                the auction.
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </>
                    )}
                    {PutOnSale === true && PutOnSaleType === "FixedPrice" && (
                      <div className="row mx-0 mt-3 fixed_price_sec">
                        <label className="primary_label" htmlFor="price_new">
                          Price
                        </label>

                        <div className="form-row w-100">
                          <div className="form-group col-md-6">
                            <div className="input-group input_grp_style_1">
                              <input
                                type="text"
                                className="form-control selct_form_input_h"
                                placeholder="0"
                                aria-label="Recipient's username"
                                aria-describedby="basic-addon2"
                                name="TokenPrice"
                                id="TokenPrice"
                                step="0.01"
                                maxLength={15}
                                autoComplete="off"
                                onChange={inputChange}
                                value={TokenPrice}
                              />
                              <div className="input-group-append">
                                <Select
                                  className="yes1 form-control primary_inp select1 selxet_app"
                                  id="basic-addon2"
                                  name="coinname"
                                  onChange={priceoptionfunc}
                                  options={priceoption}
                                  label="Select price"
                                  // formControlProps={{
                                  //   fullWidth: true
                                  // }}
                                />
                              </div>
                            </div>

                            {ValidateError.TokenPrice && (
                              <span className="text-danger">
                                {ValidateError.TokenPrice}
                              </span>
                            )}
                          </div>
                        </div>
                        <p className="form_note">
                          Service fee
                          <span className="font_we_700_note_txt">
                            {Wallet_Details.Service_Fee_seller / 1e18}%{" "}
                          </span>
                          <br />
                          You will receive{" "}
                          <span className="font_we_700_note_txt">
                            {/* {YouWillGet} */}
                            <Convert
                              item={Number(YouWillGet)}
                              coinName={CoinName}
                              convertVal={1}
                            />
                            {CoinName}
                          </span>
                          <span className="font_we_700_note_txt">
                            <br />

                            {/* $( {CoinName == "CAKE" ? Wallet_Details.Token_convertion[0].USD * TokenPrice : Wallet_Details.Token_convertion[0].USD * TokenPrice}) */}
                          </span>
                        </p>
                      </div>
                    )}
                    {PutOnSale === true && PutOnSaleType === "TimedAuction" && (
                      <div className="row mt-3 timed_sec">
                        <div className="col-12 mb-3">
                          <label className="primary_label" htmlFor="price_new">
                            Minimum bid
                          </label>
                          <div className="input-group mb-1">
                            <input
                              type="text"
                              className="form-control selct_form_input_h"
                              placeholder="Enter minimum bid"
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon3"
                              name="MinimumBid"
                              id="MinimumBid"
                              maxLength={CONFIG.maxLength}
                              onChange={inputChange}
                              value={MinimumBid}
                              autoComplete="off"
                            />
                            <div className="input-group-append">
                              <Select
                                className="yes1 form-control primary_inp select1 selxet_app"
                                id="basic-addon2"
                                isSearchable={false}
                                name="coinname"
                                value={{
                                  label: CoinName ? CoinName : "Select Coin",
                                  value: CoinName ? CoinName : "Select Coin",
                                }}
                                onChange={priceoptionfunc}
                                options={
                                  priceoption &&
                                  priceoption.filter(
                                    (item) =>
                                      item?.label !=
                                      Wallet_Details?.networkConfiguration
                                        ?.currencySymbol,
                                  )
                                }
                                label="Select price"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />

                              {/* <p className="yes1 form-control primary_inp selxet_app symboldbo">{Wallet_Details.networkConfiguration.tokenSymbol
                              // NetworkName == 'binance' ? network.BSC.tokenSymbol : network.ETH.tokenSymbol
                              }</p> */}
                            </div>
                          </div>

                          {ValidateError.MinimumBid && (
                            <span className="text-danger">
                              {ValidateError.MinimumBid}
                            </span>
                          )}
                          {/* {ValidateError.TokenPrice && (
                            <span className="text-danger">
                              {ValidateError.TokenPrice}
                            </span>
                          )} */}

                          <p className="form_note">
                            {" "}
                            Bids below this amount won't be allowed. If you not
                            enter any amount we will consider as 0
                          </p>
                        </div>
                        <div className="col-12 col-lg-6  mb-3">
                          <div className="single_dd_1">
                            <label
                              className="primary_label"
                              htmlFor="start_date"
                            >
                              Starting Date
                            </label>
                            <div className="dropdown">
                              <button
                                className="btn btn-secondary dropdown-toggle filter_btn"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {StartDate}
                                <i className="fas fa-chevron-down"></i>
                              </button>
                              <div
                                className="dropdown-menu filter_menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <div
                                  id="RightAfterListing"
                                  onClick={() => {
                                    DateChange(
                                      "StartDateDropDown",
                                      "RightAfterListing",
                                    );
                                  }}
                                >
                                  Right after listing
                                </div>
                                <div
                                  id="PickStart"
                                  onClick={() => {
                                    DateChange(
                                      "StartDateDropDown",
                                      "PickStartDate",
                                    );
                                  }}
                                >
                                  Pick specific date
                                </div>
                              </div>
                            </div>
                            {ValidateError.Clocktime && (
                              <span className="text-danger">
                                {ValidateError.Clocktime}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-lg-6 mb-3">
                          <div className="single_dd_1">
                            <label
                              className="primary_label"
                              htmlFor="start_date"
                            >
                              Expiration Date
                            </label>
                            <div className="dropdown">
                              <button
                                className="btn btn-secondary dropdown-toggle filter_btn"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {EndDate}
                                <i className="fas fa-chevron-down"></i>
                              </button>
                              <div
                                className="dropdown-menu filter_menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <div
                                  onClick={() => {
                                    DateChange("EndDateDropDown", "1 Day");
                                  }}
                                >
                                  1 day
                                </div>
                                <div
                                  onClick={() => {
                                    DateChange("EndDateDropDown", "3 Day");
                                  }}
                                >
                                  3 days
                                </div>
                                <div
                                  onClick={() => {
                                    DateChange(
                                      "EndDateDropDown",
                                      "PickEndDate",
                                    );
                                  }}
                                >
                                  Pick specific date
                                </div>
                              </div>
                            </div>
                            {ValidateError.EndClocktime && (
                              <span className="text-danger">
                                {ValidateError.EndClocktime}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-12">
                          <p
                            className="form_note_link_boild"
                            data-toggle="modal"
                            data-target="#learn_modal"
                          >
                            Learn more how timed auctions work
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="form-group col-md-12">
                    <div className="d-flex justify-content-between align-items-start grid_toggle">
                      <div>
                        <label className="primary_label" htmlFor="inputEmail4">
                          Unlock Once Purchased
                        </label>
                        <p className="form_note">
                          Content will be unlocked after successful transaction.
                        </p>
                      </div>
                      <label className="switch toggle_custom">
                        <input
                          type="checkbox"
                          id="unlockoncepurchased"
                          name="unlockoncepurchased"
                          onChange={CheckedChange}
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                    {Unlockoncepurchased && (
                      <div className="form-group unlock_sec">
                        <input
                          type="text"
                          className="form-control primary_inp mb-1"
                          name="UnLockcontent"
                          id="UnLockcontent"
                          onChange={inputChange}
                          placeholder="Digital key, code to redeem or link to a file.."
                        />
                        <p className="form_note">
                          Tip: Markdown syntax is supported
                        </p>
                      </div>
                    )}

                    {ValidateError.UnLockcontent && (
                      <span className="text-danger">
                        {ValidateError.UnLockcontent}
                      </span>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label className="primary_label" htmlFor="name">
                      NFT Name
                    </label>
                    <input
                      type="text"
                      className="form-control primary_inp"
                      name="TokenName"
                      id="TokenName"
                      onChange={inputChange}
                      placeholder="e.g. Redeemable"
                    />
                    {ValidateError.TokenName && (
                      <span className="text-danger">
                        {ValidateError.TokenName}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-6">
                    <label className="primary_label" htmlFor="desccription">
                      Description <span className="text-muted">(Optional)</span>
                    </label>
                    <textarea
                      type="text"
                      className="form-control primary_inp"
                      id="desccription"
                      name="TokenDescription"
                      onChange={inputChange}
                      placeholder="You have an option to give description of your NFT"
                      autoComplete="off"
                    ></textarea>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label className="primary_label" htmlFor="Collection">
                      Select Collection
                    </label>
                    <Select
                      className="yes1 typecontrol3 form-control primary_inp typecontrol"
                      id="userCollection"
                      name="userCollection"
                      onChange={selectChange}
                      maxMenuHeight={220}
                      options={CollectionList}
                      label="Select Collection"
                      classNamePrefix="react-select"
                      placeholder="Select Collection"
                      value={
                        UserCollection
                          ? {
                              label: UserCollection,
                              value: UserCollection,
                            }
                          : ""
                      }
                      // formControlProps={{
                      //   fullWidth: true
                      // }}
                    />
                    {ValidateError.userCollection && (
                      <span className="text-danger">
                        {ValidateError.userCollection}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-6 category">
                    <label className="primary_label" htmlFor="category">
                      Category
                    </label>
                    <input
                      type="text"
                      placeholder="Select Category"
                      className="form-control"
                      value={
                        CategorywithSubcategory?.display
                          ? CategorywithSubcategory?.display
                          : ""
                      }
                      onClick={() => setCategory(!category)}
                      disabled={
                        CategorywithSubcategory?.disabecategory
                          ? CategorywithSubcategory.disabecategory
                          : false
                      }
                    />
                    {category == true ? (
                      <>
                        <div className="dropdown">
                          <ul className="dropdown-menu1 p-3">
                            {fullcategory?.length > 0 &&
                              fullcategory.map((val) => {
                                return (
                                  <li className="dropdown-sub">
                                    {val.name}
                                    <ul className="sub-dropdown">
                                      {val.subcategory.map((sub) => {
                                        return (
                                          <li
                                            onClick={() =>
                                              SettokenCategory(val, sub)
                                            }
                                          >
                                            {sub}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {ValidateError.TokenCategory && (
                      <span className="text-danger">
                        <br />
                        {ValidateError.TokenCategory}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label className="primary_label" htmlFor="royalties">
                      Royalties
                    </label>
                    <div className="inp_grp">
                      <input
                        type="text"
                        className="form-control primary_inp"
                        name="TokenRoyalities"
                        onChange={inputChange}
                        id="royalties"
                        placeholder="10%"
                        value={TokenRoyalities}
                      />
                      <p className="inp_append">%</p>
                      <span>
                        Note that you may choose not to receive royalty. As
                        such, you type in 0% as royalty.
                      </span>
                      {ValidateError.TokenRoyalities && (
                        <span className="text-danger">
                          <br />
                          {ValidateError.TokenRoyalities}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="primary_label" htmlFor="properties">
                      Properties <span className="text-muted">(Optional)</span>
                    </label>
                    {/* <input type="text"
                      className="form-control primary_inp"
                      id="properties"
                      name="TokenProperties"
                      onChange={inputChange}
                      placeholder="e.g. size" /> */}
                    <span>
                      You may choose to provide in the properties of the NFT for
                      the buyer to get to know more about it.
                    </span>

                    {NFTProperties?.length > 0 &&
                      NFTProperties?.map((val, index) => {
                        return (
                          <>
                            <div className="form-group">
                              <div className="row">
                                <div className="col-sm-5">
                                  <label
                                    className="primary_label"
                                    htmlFor="royalties"
                                  >
                                    key
                                  </label>
                                  <div className="inp_grp">
                                    <input
                                      type="text"
                                      className="form-control primary_inp"
                                      name="key"
                                      onChange={(e) => OnChange(e, index)}
                                      id="key"
                                      value={val?.key}
                                      placeholder="Author Name"
                                    />
                                    {/* <p className="inp_append">%</p> */}
                                    <span>Enter Key.</span>
                                    {ValidateError?.["key" + index] && (
                                      <span className="text-danger">
                                        <br />
                                        {ValidateError?.["key" + index]}
                                      </span>
                                    )}

                                    <div className="col-lg-9 mb-4 mb-lg-0 col-md-1">
                                      <div className="form-group">
                                        {/* <div className="row">
                                          <div className="col-2">
                                            <img
                                              src={delete_png}
                                              onClick={() =>
                                                removeFilters(
                                                  index,
                                                  "properties"
                                                )
                                              }
                                              alt="delete"
                                              className="img-fluid delete_png"
                                              width={30}
                                            />
                                          </div>
                                        </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-5">
                                  <div className="row mx-auto">
                                    <div className="col-9 col-sm-12 px-0">
                                      <div className="form-group">
                                        <label
                                          className="primary_label"
                                          htmlFor="royalties"
                                        >
                                          value
                                        </label>
                                        <div className="inp_grp">
                                          <input
                                            type="text"
                                            className="form-control primary_inp"
                                            name="value"
                                            onChange={(e) => OnChange(e, index)}
                                            id="value"
                                            value={val?.value}
                                            placeholder="Willam Shakespeare"
                                          />
                                          {/* <p className="inp_append">%</p> */}
                                          <span>Enter Value.</span>
                                          {ValidateError?.["value" + index] && (
                                            <span className="text-danger">
                                              <br />
                                              {ValidateError?.["value" + index]}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex align-items-center justify-content-center d-sm-none">
                                      <img
                                        src={delete_png}
                                        onClick={() =>
                                          removeFilters(index, "properties")
                                        }
                                        alt="delete"
                                        className="img-fluid delete_png d-block"
                                        style={{ cursor: "pointer" }}
                                        width={30}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-2 d-none d-sm-flex align-items-center justify-content-center">
                                  <img
                                    src={delete_png}
                                    onClick={() =>
                                      removeFilters(index, "properties")
                                    }
                                    alt="delete"
                                    className="img-fluid delete_png"
                                    style={{ cursor: "pointer" }}
                                    width={30}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}

                    {/* </div> */}

                    <div className="add_social mt-3">
                      <div className="btn_sec">
                        <button
                          type="button"
                          className="btn btn-add-social blue_btn"
                          onClick={() => addFilters("properties")}
                        >
                          {" "}
                          <FaPlus />
                        </button>
                        <span className="add_txt clk_add_txt">
                          Click to Add
                        </span>
                      </div>
                    </div>
                  </div>

                  {location_pathname === "create-multiple" && (
                    <>
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="desccription">
                          Total Number of copies(NFT Quantity)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="TokenQuantity"
                          name="TokenQuantity"
                          onChange={inputChange}
                          placeholder="e.g. 1"
                          value={TokenQuantity}
                          maxLength={7}
                          autoComplete="off"
                        />
                        <span>
                          Specify the number of copies of the NFT you want to
                          mint.
                        </span>
                        {ValidateError.TokenQuantity && (
                          <span className="text-danger">
                            <br />
                            {ValidateError.TokenQuantity}
                          </span>
                        )}
                      </div>
                      {WhiteListUser?.some(
                        (val) => NumberChange(val?.Quantity) > 0,
                      ) ? (
                        <div className="form-group col-md-6">
                          <label
                            className="primary_label"
                            htmlFor="desccription"
                          >
                            Copies for Yourself
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="OwnerQuantity"
                            name="OwnerQuantity"
                            onChange={inputChange}
                            placeholder="e.g. 1"
                            value={OwnerQuantity}
                            autoComplete="off"
                            disabled={true}
                          />
                          <span className="text_title">
                            Specify the number of copies of the NFT you want to
                            mint.
                          </span>
                          {ValidateError.TokenQuantity && (
                            <span className="text-danger">
                              <br />
                              {ValidateError.TokenQuantity}
                            </span>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  )}

                  {ListNFT && (
                    <div className="form-group col-md-6">
                      <label className="primary_label" htmlFor="desccription">
                        List Quantity
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="ListedQuantity"
                        name="ListedQuantity"
                        onChange={inputChange}
                        placeholder="e.g. 1"
                        value={ListedQuantity}
                        maxLength={7}
                        disabled={location_pathname === "create-single"}
                        autoComplete="off"
                      />
                      <span>
                        Specify the number of copies you have to list for sale.
                      </span>
                      {ValidateError.ListedQuantity && (
                        <span className="text-danger">
                          <br />
                          {ValidateError.ListedQuantity}
                        </span>
                      )}
                    </div>
                  )}

                  {PutOnSale && (
                    <div className="form-group col-md-6">
                      <label className="primary_label" htmlFor="desccription">
                        Quantity for Sale
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="PutOnSaleQuantity"
                        name="PutOnSaleQuantity"
                        onChange={inputChange}
                        placeholder="e.g. 1"
                        value={PutOnSaleQuantity}
                        maxLength={7}
                        disabled={location_pathname === "create-single"}
                        autoComplete="off"
                      />
                      <span>
                        Specify the number of copies you have to list for sale.
                      </span>
                      {ValidateError.PutOnSaleQuantity && (
                        <span className="text-danger">
                          <br />
                          {ValidateError.PutOnSaleQuantity}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="form-row w-100">
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="name">
                        Social Media Links
                      </label>
                    </div>
                  </div>
                  <div className="social_add_sec">
                    <p className="text_title">
                      Interactive media links, e.g. Facebook, Telegram, Twitter,
                      Instagram, etc.
                    </p>

                    <div className="add_social">
                      <div className="btn_sec">
                        <button
                          type="button"
                          className="btn btn-add-social"
                          onClick={addFilters}
                        >
                          {" "}
                          <FaPlus />
                        </button>
                        <span className="add_txt">Click to Add</span>
                      </div>
                    </div>
                    {filterRows.map((val, index) => (
                      <div className="url_card my-3" key={index}>
                        <label className="primary_label" htmlFor="name">
                          URL For
                        </label>
                        <div className="row first_row">
                          <div className="col-lg-3 mb-4 mb-lg-0">
                            <Select
                              id="urfor"
                              // menuIsOpen={true}
                              options={mappedData}
                              classNamePrefix="react-select"
                              className="yes1 typecontrol3 form-control primary_inp typecontrol"
                              onChange={(e) => OnChange(e, index)}
                              value={
                                socialLinks[index]?.urlfor
                                  ? {
                                      label: socialLinks[index].urlfor,
                                      value: socialLinks[index].urlfor,
                                    }
                                  : ""
                              }
                            />
                            {ValidateError["urlfor" + index] && (
                              <span className="text-danger">
                                {ValidateError["urlfor" + index]}
                              </span>
                            )}
                          </div>
                          <div className="col-lg-9 mb-4 mb-lg-0">
                            <div className="row">
                              <div className="col-10">
                                <form>
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="url"
                                      aria-describedby="emailHelp"
                                      placeholder="Enter url"
                                      onChange={(e) => OnChange(e, index)}
                                      value={socialLinks[index]?.url || ""}
                                    />
                                    {ValidateError["url" + index] && (
                                      <span className="text-danger">
                                        {ValidateError["url" + index]}
                                      </span>
                                    )}
                                  </div>
                                </form>
                              </div>
                              <div className="col-2">
                                <img
                                  src={delete_png}
                                  onClick={() => removeFilters(index)}
                                  alt="delete"
                                  className="img-fluid delete_png"
                                  width={30}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {NumberChange(CollectibleType) != 721 && !LazyMint ? (
                    <>
                      <div className="form-row w-100">
                        <div className="form-group col-md-12">
                          <label className="primary_label" htmlFor="name">
                            WhiteList Users
                          </label>
                        </div>
                      </div>
                      <div className="social_add_sec mb-3">
                        <p className="text_title">
                          You Can Add User WalletAddress Who can see your
                          complete nfts
                        </p>

                        <div className="add_social">
                          <div className="btn_sec">
                            <button
                              type="button"
                              className="btn btn-add-social"
                              onClick={() => AddField("whitelist")}
                            >
                              {" "}
                              <FaPlus />
                            </button>
                            <span className="add_txt">Click to Add</span>
                          </div>
                        </div>
                        {WhiteListUser.map((val, index) => (
                          <div className="url_card my-3" key={index}>
                            <label className="primary_label" htmlFor="name">
                              Select Wallet Address
                            </label>
                            <div className="row first_row">
                              <div className="col-10 mb-4 mb-lg-0">
                                <form>
                                  <div class="form-group">
                                    <Select
                                      id="Address"
                                      options={WhiteListOptions?.filter(
                                        (checkdata) =>
                                          !WhiteListUser.some(
                                            (selected) =>
                                              selected?.Address ==
                                              checkdata.label,
                                          ),
                                      )}
                                      classNamePrefix="react-select"
                                      className="yes1 typecontrol3 form-control primary_inp typecontrol"
                                      onChange={(e) =>
                                        OnChange(e, index, "Address")
                                      }
                                      value={
                                        WhiteListUser[index]?.Address
                                          ? {
                                              label:
                                                WhiteListUser[index].Address,
                                              value:
                                                WhiteListUser[index].Address,
                                            }
                                          : ""
                                      }
                                      name={"whitelist"}
                                    />
                                    {ValidateError[
                                      "whitelistaddress" + index
                                    ] && (
                                      <span className="text-danger">
                                        {
                                          ValidateError[
                                            "whitelistaddress" + index
                                          ]
                                        }
                                      </span>
                                    )}
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="Address"
                                      aria-describedby="emailHelp"
                                      placeholder="Enter Quantity"
                                      onChange={(e) => OnChange(e, index)}
                                      name="Quantity"
                                      value={val?.Quantity || ""}
                                    />
                                    {/* <input type="text" id="Whitelist" value={val||''} /> */}
                                    {ValidateError[
                                      "whitelistquantity" + index
                                    ] && (
                                      <span className="text-danger">
                                        {
                                          ValidateError[
                                            "whitelistquantity" + index
                                          ]
                                        }
                                      </span>
                                    )}
                                  </div>
                                </form>
                              </div>
                              <div className="col-2 d-flex justify-content-center">
                                <img
                                  src={delete_png}
                                  onClick={() =>
                                    RemoveField(index, "whitelist")
                                  }
                                  alt="delete"
                                  className="img-fluid delete_png"
                                  width={30}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="mb-3 mt-4">
                  <div className="d-flex agreement mb-0">
                    <input
                      type="checkbox"
                      id="original"
                      name="original"
                      value="Agreement"
                      checked={agree.original}
                      onChange={() =>
                        SetAgree({ ...agree, ...{ original: !agree.original } })
                      }
                    />
                    <label for="vehicle1" className="ml-2">
                      I declare that this is an original artwork. I understand
                      that no plagiarism is allowed, and that the artwork can be
                      removed anytime if detected.
                    </label>
                  </div>
                  {ValidateError.original && (
                    <span className="text-danger ms-3">
                      {ValidateError.original}
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <div className="d-flex agreement mb-0">
                    <input
                      type="checkbox"
                      id="termsandcondition"
                      name="termsandcondition"
                      value="Car"
                      checked={agree.termsandcondition}
                      onChange={() =>
                        SetAgree({
                          ...agree,
                          ...{ termsandcondition: !agree.termsandcondition },
                        })
                      }
                    />
                    <label for="vehicle2" className="ml-2">
                      I have read and I agree to all the NFT{" "}
                      <Link
                        to={
                          "https://info.edaface.com/index.php/knowledge-base/article/nft-marketplace-terms-and-conditions"
                        }
                        target="_blank"
                      >
                        Terms & Conditions
                      </Link>{" "}
                      and all legal requirements of EDA
                    </label>
                  </div>
                  {ValidateError.termsandcondition && (
                    <span className="text-danger ms-3">
                      {ValidateError.termsandcondition}
                    </span>
                  )}
                </div>
              </form>
              <div>
                <button
                  className="create_btn"
                  // type ="button"
                  data-toggle="model"
                  data-target="#create_item_modal"
                  onClick={CreateItem}
                >
                  Create item
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
      {/* Choose Collection Modal */}
      <div
        className="modal fade primary_modal"
        id="choose_collection_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="choose_collection_modalCenteredLabel"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-sm"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <h5 className="modal-title" id="choose_collection_modalLabel">
                Collection
              </h5>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex align-items-center flex_block_mob">
                <div className="hex center">
                  <div className="hex__shape">
                    <div className="hex__shape">
                      <div className="hex__shape">
                        <img
                          src={require("../assets/images/img_01.png")}
                          alt="logo"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="font_14 font_600 line_20 mb-1 text_brown mb-3">
                    We recommend an image of at least 400x400. Gifs work too.
                  </p>
                  <div className="file_btn primary_btn d-inline-block btn_small">
                    Choose File
                    <input className="inp_file" type="file" name="file" />
                  </div>
                </div>
              </div>
              <form>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label className="primary_label_dark" htmlFor="name">
                      Display Name{" "}
                      <span className="text-muted">(30 available)</span>
                    </label>
                    <input
                      type="text"
                      className="form-control primary_inp"
                      id="name"
                      placeholder="Enter token name"
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <label
                      className="primary_label_dark"
                      htmlFor="desccription"
                    >
                      Symbol <span className="text-muted">(required)</span>
                    </label>
                    <input
                      type="text"
                      className="form-control primary_inp"
                      id="desccription"
                      placeholder="Enter token symbol"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label className="primary_label_dark" htmlFor="name">
                      Description <span className="text-muted">(Optional)</span>
                    </label>
                    <input
                      type="text"
                      className="form-control primary_inp"
                      id="name"
                      placeholder="Spread some words about token collection"
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <label
                      className="primary_label_dark"
                      htmlFor="desccription"
                    >
                      Short url
                    </label>
                    <input
                      type="text"
                      className="form-control primary_inp"
                      id="desccription"
                      defaultValue="Fayre.io/"
                    />
                  </div>
                </div>
                <div className="text-center">
                  <button className="create_btn btn-block">
                    Create Collection
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* ens choose collection modal */}
      {/* create_item Modal */}
      {/* <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true"> */}
      <div
        className="modal fade primary_modal"
        id="create_item_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="create_item_modalCenteredLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-sm"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <h5 className="modal-title" id="create_item_modalLabel">
                Follow Steps
              </h5>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                {!LazyMint && (
                  <>
                    <div className="media approve_media">
                      {ApproveCallStatus === "init" && (
                        <i
                          className="fas fa-check mr-3 pro_initial"
                          aria-hidden="true"
                        ></i>
                      )}
                      {ApproveCallStatus === "processing" && (
                        <i
                          className="fa fa-spinner mr-3 spinner_icon"
                          aria-hidden="true"
                        ></i>
                      )}
                      {ApproveCallStatus === "done" && (
                        <i
                          className="fas fa-check mr-3 pro_complete"
                          aria-hidden="true"
                        ></i>
                      )}
                      {ApproveCallStatus === "tryagain" && (
                        <i
                          className="fa fa-spinner mr-3 spinner_icon"
                          aria-hidden="true"
                        ></i>
                      )}

                      <div className="media-body">
                        <p className="mt-0 approve_text">Upload Meta Data</p>
                        <p className="mt-0 approve_desc">
                          {cmsindex?.["Ipfs Upload"] ||
                          cmsindex?.["Ipfs Upload"] == 0 ? (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: CMS[cmsindex?.["Ipfs Upload"]]?.answer,
                              }}
                            ></p>
                          ) : (
                            "IPFS refers to Inter Planetary File System. This is where your NFT file will be stored for easy access."
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="text-center my-3">
                      <button
                        className="create_btn btn-block"
                        disabled={
                          ApproveCallStatus === "processing" ||
                          ApproveCallStatus === "done"
                        }
                        onClick={ApproveCall}
                      >
                        {" "}
                        {ApproveCallStatus === "processing" && (
                          <i
                            className="fa fa-spinner mr-3 spinner_icon"
                            aria-hidden="true"
                            id="circle1"
                          ></i>
                        )}
                        {ApproveCallStatus === "init" && "Approve"}
                        {ApproveCallStatus === "processing" && "In-progress..."}
                        {ApproveCallStatus === "done" && "Done"}
                        {ApproveCallStatus === "tryagain" && "Try Again"}
                      </button>
                    </div>
                  </>
                )}

                {approvecheck && (
                  <div className="media approve_media">
                    {ApproveTrade === "init" && (
                      <i
                        className="fas fa-check mr-3 pro_initial"
                        aria-hidden="true"
                      ></i>
                    )}
                    {ApproveTrade === "processing" && (
                      <i
                        className="fa fa-spinner mr-3 spinner_icon"
                        aria-hidden="true"
                      ></i>
                    )}
                    {ApproveTrade === "done" && (
                      <i
                        className="fas fa-check mr-3 pro_complete"
                        aria-hidden="true"
                      ></i>
                    )}
                    {ApproveTrade === "tryagain" && (
                      <i
                        className="fa fa-spinner mr-3 spinner_icon"
                        aria-hidden="true"
                      ></i>
                    )}

                    <div className="media-body">
                      <p className="mt-0 approve_text">Get Approve </p>
                      {/* <p className="mt-0 approve_desc">Upload meta contents to ipfs</p> */}
                    </div>
                  </div>
                )}
                {approvecheck && (
                  <div className="text-center my-3">
                    <button
                      className="create_btn btn-block"
                      disabled={
                        ApproveCallStatus !== "done" ||
                        ApproveTrade === "processing" ||
                        ApproveTrade === "done"
                      }
                      onClick={getapproveFun}
                    >
                      {" "}
                      {ApproveTrade === "processing" && (
                        <i
                          className="fa fa-spinner mr-3 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      )}
                      {ApproveTrade === "init" && "Approve"}
                      {ApproveTrade === "processing" && "In-progress..."}
                      {ApproveTrade === "done" && "Done"}
                      {ApproveTrade === "tryagain" && "Try Again"}
                    </button>
                  </div>
                )}

                {LazyMint ? (
                  <>
                    <div className="media approve_media">
                      {LazymintStatus === "init" && (
                        <i
                          className="fas fa-check mr-3 pro_initial"
                          aria-hidden="true"
                        ></i>
                      )}
                      {LazymintStatus === "processing" && (
                        <i
                          className="fa fa-spinner mr-3 spinner_icon"
                          aria-hidden="true"
                        ></i>
                      )}
                      {LazymintStatus === "done" && (
                        <i
                          className="fas fa-check mr-3 pro_complete"
                          aria-hidden="true"
                        ></i>
                      )}
                      {LazymintStatus === "tryagain" && (
                        <i
                          className="fa fa-spinner mr-3 spinner_icon"
                          aria-hidden="true"
                        ></i>
                      )}

                      <div className="media-body">
                        <p className="mt-0 approve_text">
                          Upload files For LazyMinting
                        </p>
                        <p className="mt-0 approve_desc">NFT Upload</p>
                      </div>
                    </div>
                    <div className="text-center my-3">
                      <button
                        className="create_btn btn-block"
                        disabled={
                          (ApproveCallStatus !== "done" &&
                            (ApproveTrade !== "done" ||
                              approvecheck === false)) ||
                          LazymintStatus === "processing" ||
                          LazymintStatus === "done"
                        }
                        onClick={() => LazyMintFunc()}
                      >
                        {LazymintStatus === "processing" && (
                          <i
                            className="fa fa-spinner mr-3 spinner_icon"
                            aria-hidden="true"
                            id="circle1"
                          ></i>
                        )}
                        {LazymintStatus === "init" && "Start"}
                        {LazymintStatus === "processing" && "In-progress..."}
                        {LazymintStatus === "done" && "Done"}
                        {LazymintStatus === "tryagain" && "Try Again"}
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="media approve_media">
                      {MintCallStatus === "init" && (
                        <i
                          className="fas fa-check mr-3 pro_initial"
                          aria-hidden="true"
                        ></i>
                      )}
                      {MintCallStatus === "processing" && (
                        <i
                          className="fa fa-spinner mr-3 spinner_icon"
                          aria-hidden="true"
                        ></i>
                      )}
                      {MintCallStatus === "done" && (
                        <i
                          className="fas fa-check mr-3 pro_complete"
                          aria-hidden="true"
                        ></i>
                      )}
                      {MintCallStatus === "tryagain" && (
                        <i
                          className="fa fa-spinner mr-3 spinner_icon"
                          aria-hidden="true"
                        ></i>
                      )}

                      <div className="media-body">
                        <p className="mt-0 approve_text">
                          Upload files & Mint token
                        </p>
                        <p className="mt-0 approve_desc">
                          Call contract method
                        </p>
                      </div>
                    </div>
                    <div className="text-center my-3">
                      <button
                        className="create_btn btn-block"
                        disabled={
                          (ApproveCallStatus !== "done" &&
                            (ApproveTrade !== "done" ||
                              approvecheck === false)) ||
                          MintCallStatus === "processing" ||
                          MintCallStatus === "done"
                        }
                        onClick={MintCall}
                      >
                        {MintCallStatus === "processing" && (
                          <i
                            className="fa fa-spinner mr-3 spinner_icon"
                            aria-hidden="true"
                            id="circle1"
                          ></i>
                        )}
                        {MintCallStatus === "init" && "Start"}
                        {MintCallStatus === "processing" && "In-progress..."}
                        {MintCallStatus === "done" && "Done"}
                        {MintCallStatus === "tryagain" && "Try Again"}
                      </button>
                    </div>
                  </>
                )}

                <div className="media approve_media"></div>
                <div className="text-center my-3"></div>

                <div className="media approve_media"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* end create_item modal */}

      {/* learn Modal */}
      <div
        className="modal fade primary_modal"
        id="learn_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="learn_modalCenteredLabel"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <h5 className="modal-title" id="learn_modalLabel">
                How timed auction work
              </h5>

              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>
                When you put your item on timed auction, you choose currency,
                minimum bid, starting and ending dates of your auction.
              </p>

              <p>
                The bidder can only place a bid which satisfies the following
                conditions:
              </p>
              <ol>
                <li>It is at least minimum bid set for the auction</li>
                <li>It is at least 5% higher than the current highest bid</li>
              </ol>

              <p>
                Note that some bids may disappear with time if the bidder
                withdraws their balance. At the same time, some bids may
                reappear if the bidder has topped up their balance again.
              </p>

              <p>
                Auction cannot be cancelled after any valid bid was made. Any
                bid placed in the last 10 minutes extends the auction by 10
                minutes.
              </p>

              <p>
                In the 48 hours after the auction ends you will only be able to
                accept the highest available bid placed during the auction. As
                with regular bids, you will need to pay some gas to accept
                it.Note that you can always decrease the price of your listing
                for free, without making a transaction or paying gas. You can
                view all your items here.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* end learn modal */}

      {/* calendar Modal */}
      <div
        className="modal fade primary_modal"
        id="calendar_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="calendar_modalCenteredLabel"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-sm"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <h5 className="modal-title" id="calendar_modalLabel">
                Choose date
              </h5>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="pb-3">
                <Datetime
                  input={false}
                  value={Clocktime}
                  onChange={(value) =>
                    checkSelectedTimeValid("startTime", value)
                  }
                  isValidDate={validStartTime}
                />
              </div>
              <div className="text-center pb-3">
                <button
                  className="create_btn"
                  onClick={() => ModalAction("calendar_modal", "hide")}
                  id="doneStartDate"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end calendar modal */}
      {/* calendar Modal */}
      <div
        className="modal fade primary_modal"
        id="calendar_modal_expire"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="calendar_modalCenteredLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-sm"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <h5 className="modal-title" id="calendar_modalLabel">
                Choose date
              </h5>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="pb-3">
                <Datetime
                  input={false}
                  value={EndClocktime}
                  onChange={(value) => checkSelectedTimeValid("endTime", value)}
                  isValidDate={validEndTime}
                />
              </div>
            </div>
            <div className="text-center">
              <button
                className="primary_btn"
                id="doneEndDate"
                onClick={() => ModalAction("calendar_modal_expire", "hide")}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
